import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { diffWords } from 'diff';
import {
	Row,
	Col,
	Button,
	Space,
	Result,
	notification,
	Skeleton,
	Tooltip,
	Drawer,
} from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
	XContainer,
	XForm,
	XModal,
	XAffix,
	ChatButton,
	ChatBoxWrap,
	XThemeContainer,
	XThemeAffixCard,
	XThemeForm,
	XThemeModal,
	XThemeInputText,
	XThemeFilterCircleButton,
} from '../../styles/GlobalThemeStyle';
import {
	ArrowDownOutlined,
	ArrowLeftOutlined,
	ArrowsAltOutlined,
	CloseOutlined,
	EyeOutlined,
	MinusCircleOutlined,
	MinusOutlined,
	ShrinkOutlined,
	UserOutlined,
	WarningOutlined,
} from '@ant-design/icons';
import {
	XButtonBack,
	XAddCodeSticky,
	RevisionHistoryNum,
	RevisionHisTitle,
	EyeIcon,
	CurrentRevision,
	XThemeCardBackBgVersion,
	XThemeMobileTimeVHistoryWrapper,
	XThemeMobileCaseDetailsHeader,
	XThemMainTitle,
	XThemeCardCaseOperations,
	XThemeAvatarName,
	XThemeAvatarText,
	XThemeAddressWrap,
	XThemeExpendBtn,
	XVerHistorySticky,
	DrawerVersionLog,
	XThemeMotionMode,
} from '../CaseForm/CaseFormStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { XLottie } from '../Login/LoginStyle';
// import AppealLoading from '../../json/reloading.json';
import AppealLoading from '../../json/AppealLetter.json';
import AnalysisLoader from '../../components/AnalysisLoader/AnalysisLoader';
import DownloadAnimation from '../../json/download.json';

// actions
import { editCaseApi, editCaseReset } from '../../actions/editCaseAction';
import { addCaseApi, addCaseReset } from '../../actions/addCaseAction';
import {
	analyseCoverageApi,
	analyseCoverageReset,
} from '../../actions/analyseCoverageAction';
import {
	reviseCoverageApi,
	reviseCoverageReset,
} from '../../actions/reviseCoverageAction';
import {
	sendFeedbackApi,
	sendFeedbackReset,
} from '../../actions/sendFeedbackAction';
import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../actions/getAnalysisAction';
import {
	checkModulePermissions,
	getUserToken,
	disableFutureDates,
	toTitleCase,
} from '../../utils/helper';
import dayjs from 'dayjs';
import {
	XDivider,
	XPara1,
	XLottieMargin,
	XLottieOverlay,
	XButtonConfirm,
	XNotificationBar,
	XButtonReload,
	XButtonCloseBar,
	XLottieLetter,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import Header from '../../components/Header/Header';
import Timeline from '../../components/HorizontalTimeline/Timeline';
import NewTimeline from '../../components/HorizontalTimeline/NewTimeline';
//Todo Chatbox commented for Demo Branch
import ChatBox from '../../components/Chat/Chat';
import Thanks from '../../json/thanksNew1.json';
import axios from 'axios';
import config from '../../config';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '../../components/HorizontalTimeline/index.css';
import { filterByLabel } from '../../utils/formFunctions';
// Prepare letter
import {
	getAppealLetterApi,
	getAppealLetterReset,
} from '../../actions/getAppealLetterAction';
import { saveAppealLetterApi } from '../../actions/saveAppealLetterAction';
import { generateAppealLetterApi } from '../../actions/generateAppealLetterAction';
import { getConfigurationsApi } from '../../actions/getConfigurationsAction';
import PrepareLetter from '../../components/HorizontalTimeline/PrepareLetter';
import CaseOperations from '../../components/HorizontalTimeline/CaseOperations';
import DrawerCodingTools from '../../components/CodingTools/DrawerCodingTools';
import {
	getRevisionApi,
	getRevisionReset,
} from '../../actions/getRevisionAction';
import { XThemeAffixTabs } from './AppealLetterPreviewStyle';
import Page404 from '../Page404';
import {
	Theme,
	XTheme2AffixCard,
	XTheme2Button,
	XTheme2MainTitle2,
	XTheme2TableCircleTag,
} from '../../styles/GlobalThemeStyleCQ';
import { motion, AnimatePresence } from 'framer-motion';

const CaseForm = (props) => {
	const [form] = XForm.useForm();
	const [updateForm] = XForm.useForm();
	const [newOptionForm] = XForm.useForm();
	const {
		analyseCoverage,
		analyseCoverageReset,
		analyseCoverageState,
		reviseCoverage,
		reviseCoverageReset,
		reviseCoverageState,
		editCaseReset,
		editCaseState,
		getAnalysisState,
		getAnalysis,
		getAnalysisReset,
		sendFeedback,
		sendFeedbackReset,
		sendFeedbackState,
		editCase,
		getAppealLetter,
		getAppealLetterState,
		getConfigurationsState,
		getConfigurations,
		getRevision,
		getRevisionReset,
		getRevisionState,
		getAppealLetterReset,
		collapsed,
	} = props;

	const location = useLocation();

	const pathnameIncludesCaseMA = location.pathname.includes('/case/ma/');

	const navigate = useNavigate();
	const id = useParams().id;
	const [formData, setFormData] = useState({
		status: 'success',
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
		case_amount: null,
		claim_amount: null,
		status_logs: [],
	});
	const [patientData, setPatientData] = useState({});
	const [revenueCycleFormData, setRevenueCycleFormData] = useState({
		id: id,
		appeal_status: '',
		claim_category: '',
		claim_amount: null,
		status: '',
		revenue_cycle_stage: '',
		is_claim_amount_settled: null,
		claim_amount_updated_at: '',
		appeal_status_updated_at: '',
		reimbursed_at: '',
		revenue_cycle_updates: {
			revenue_cycle_status: '',
			appeal_status: '',
			remarks: '',
			url: [],
		},
		denial_reason: '',
		denial_code1: '',
		denial_code2: '',
	});
	const [pageContent, setPageContent] = useState({
		pastHistory: [],
		presentComplaint: [],
		recommendedProcedure: [],
		medicalCoverage: [],
	});
	const [flag, setFlag] = useState(true);
	const [matchGender, setMatchGender] = useState(true);
	const [feedbackId, setFeedbackId] = useState(null);
	const [loading, setLoading] = useState(false);
	const [appealLetterLoading, setAppealLetterLoading] = useState(false);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [modalTextArea, setModalTextArea] = useState('');
	const [modalOpen, setModalOpen] = useState([false, '', '', '', '']);
	const [thanksModal, setThanksModal] = useState([false, '']);
	const [fileList, setFileList] = useState([]);
	const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('Upload Acknowledgement');
	const [selectedOption, setSelectedOption] = useState('textarea'); // Initial value can be 'textarea' or 'upload'
	const [revenueCycleStage, setRevenueCycleStage] = useState(''); // Initial value can be 'textarea' or 'upload'
	const [updateModalOpen, setUpdateModalOpen] = useState([false, '']);
	const [revenueCycleStatus, setRevenueCycleStatus] = useState('');
	const [timelineData, setTimelineData] = useState({});
	// Appeal Letter
	const [togglePrepareLetter, setTogglePrepareLetter] = useState(false);
	const [prepareLetterDrawerOpen, setPrepareLetterDrawerOpen] =
		useState(false);
	const [updatedFileList, setUpdatedFileList] = useState([]);
	const [submitCase, setSubmitCase] = useState(false); // Initial value can be 'textarea' or 'upload'
	const [documentsToDisplay, setDocumentsToDisplay] = useState([]);
	const [missingFieldsModal, setMissingFieldsModal] = useState(false);
	const [missingFields, setMissingFields] = useState([]);
	const [missingFieldInstructions, setMissingFieldInstructions] = useState(
		[],
	);
	const [missingFieldTitle, setMissingFieldTitle] = useState('');
	const [missingFieldsForm] = XForm.useForm();
	const [lastAnalysisData, setLastAnalysisData] = useState({});
	const [showAnalysisData, setShowAnalysisData] = useState(false);
	const [analysisCompleted, setAnalysisCompleted] = useState('');
	const [isMissingFieldsThere, setIsMissingFieldsThere] = useState(false);
	const [denialReasonData, setDenialReasonData] = useState([]);
	const [newOptionText, setNewOptionText] = useState('');
	const [newCheckBoxModal, setNewCheckBoxModal] = useState([false, null]);
	const [updateCaseLoading, setUpdateCaseLoading] = useState(false);
	const [updateModalButtonText, setUpdateModalButtonText] =
		useState('Update');
	const [approveModalOpen, setApproveModalOpen] = useState(false);
	const missingFieldsCardRef = useRef(null);
	const [mainDataLoading, setMainDataLoading] = useState(true);
	const [chatOpen, setChatOpen] = useState(false);
	const [clinicalDocumentsToDisplay, setClinicalDocumentsToDisplay] =
		useState([]);
	const [clinicalDocsForm] = XForm.useForm();
	const [showClinicalTextArea, setShowClinicalTextArea] = useState(false);
	const [isClinicalUploadModalOpen, setIsClinicalUploadModalOpen] =
		useState(false);
	const [clinicalDocsLoading, setClinicalDocsLoading] = useState(false);
	const [clinicalDocumentFileList, setClinicalDocumentFileList] = useState(
		[],
	);
	const [
		updatedClinicalDocumentFileList,
		setUpdatedClinicalDocumentFileList,
	] = useState([]);
	const [submitClinicalDocs, setSubmitClinicalDocs] = useState(false); // Initial value can be 'textarea' or 'upload'
	const [coverageloading, setCoverageLoading] = useState(false);
	const [LooksGoodLoading, setLooksGoodLoading] = useState(false);
	const [clinicalSummaryTextLoading, setClinicalSummaryTextLoading] =
		useState(false);
	const [prevActiveCollapse, setPrevActiveCollapse] = useState(null);
	const [currentActiveCollapse, setCurrentActiveCollapse] = useState(null);
	// State for holding filters
	const [icdform] = XForm.useForm();
	const [cptform] = XForm.useForm();
	const [icdFilters, setIcdFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
		related: false,
		childCode: '',
	});

	//CPT Codes
	const [cptFilters, setCptFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
	});
	const [openIcdCptDrawer, setOpenIcdCptDrawer] = useState(false);
	const [openIcdCptDrawer2, setOpenIcdCptDrawer2] = useState(false);
	const [activeCode, setActiveCode] = useState(null);
	const [icdCodes, setIcdCodes] = useState([]); // To store fetched ICD codes
	const [searchResults, setSearchResults] = useState([]); // To store search results
	const [icdLoading, setIcdLoading] = useState(false); // To manage loading state
	const [triggeredBySearch, setTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [triggeredByEnter, setTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [loadMore, setLoadMore] = useState(false); // To track search-triggered calls
	const [icdSearchLoading, setIcdSearchLoading] = useState(false); // To manage loading state
	const [cptCodes, setCptCodes] = useState([]); // To store fetched ICD codes
	const [cptLoading, setCptLoading] = useState(false); // To manage loading state
	const [cptSearchResults, setCptSearchResults] = useState([]); // To store search results
	const [cptTriggeredBySearch, setCptTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [cptTriggeredByEnter, setCptTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [cptLoadMore, setCptLoadMore] = useState(false); // To track search-triggered calls
	const [cptSearchLoading, setCptSearchLoading] = useState(false); // To manage loading state
	const [denialLetterActionPerform, setDenialLetterActionPerform] =
		useState(false);
	const [supportingDocActionPerform, setSupportingDocActionPerform] =
		useState(false);
	const [sendLetterLoading, setSendLetterLoading] = useState(false);
	const [caseClosed, setCaseClosed] = useState(false);
	const [activeKey, setActiveKey] = useState('1');
	const [revisionList, setRevisionList] = useState([]);
	const [currentRevision, setCurrentRevision] = useState({});
	const [versionNumber, setVersionNumber] = useState('');
	const [typeAppeal, setTypeAppeal] = useState('');
	const [fromBatchDetails, setFromBatchDetails] = useState(false);

	useEffect(() => {
		if (
			currentRevision?.field === 'past_history' ||
			currentRevision?.field === 'present_complaint' ||
			currentRevision?.field === 'suggested_treatment'
		) {
			const diff = findArrayDifferences(
				currentRevision?.oldValue,
				currentRevision?.newValue,
			);

			// Only update if `finalValue` is different to avoid unnecessary re-renders
			if (
				!currentRevision?.finalValue ||
				JSON.stringify(currentRevision.finalValue) !==
					JSON.stringify(diff)
			) {
				setCurrentRevision((prevRevision) => ({
					...prevRevision,
					finalValue: diff,
				}));
			}
		} else if (
			currentRevision?.field === 'clinical_summary' ||
			currentRevision?.field === 'summary_docs'
		) {
			// Function to generate highlighted text
			if (!currentRevision?.finalValue) {
				const diff = diffWords(
					currentRevision?.oldValue || '',
					currentRevision?.newValue || '',
				);
				const result = diff.map((part, index) => {
					// Determine if a space should be added
					const space = index < diff.length - 1 ? ' ' : '';

					if (part.added) {
						return (
							<span
								key={index}
								style={{
									backgroundColor: '#e1fcef',
									color: '#14804a',
								}}
							>
								{part.value}
							</span>
						);
					} else if (part.removed) {
						return (
							<span
								key={index}
								style={{
									backgroundColor: '#FFE9DA',
									color: '#cf1322',
								}}
							>
								{part.value}
								{/* {space} */}
							</span>
						);
					}
					return <span key={index}>{part.value}</span>;
				});

				setCurrentRevision((prevRevision) => ({
					...prevRevision,
					finalValue: result,
				}));
			}
		}
	}, [currentRevision]);

	function findArrayDifferences(oldArray, newArray) {
		const removedItems = oldArray.filter(
			(item) => !newArray.includes(item),
		);
		const addedItems = newArray.filter((item) => !oldArray.includes(item));

		return [
			...removedItems.map((item) => ({ value: item, type: 'removed' })),
			...addedItems.map((item) => ({ value: item, type: 'added' })),
			...newArray
				.filter((item) => oldArray.includes(item))
				.map((item) => ({ value: item, type: 'unchanged' })),
		];
	}

	useEffect(() => {
		if (modalOpen[0] && modalOpen[4] !== 'feedbackSummary') {
			// Check if modal is open and it's not the feedbackSummary modal
			const [description, code] = modalTextArea.split(' - ');
			form.setFieldsValue({
				modal_text_area: description || '', // Prepopulate description
				code: code ? code.split(': ')[1] : '', // Extract and prepopulate code
			});
		}
	}, [modalOpen, modalTextArea, form]);

	const handleTabsChange = (key) => {
		console.log('key in handleTabsChange', key, typeof key);
		setActiveKey(key);
		setCurrentRevision({});
		setVersionNumber('');
		if (key === '2') {
			getRevision({
				id: id,
			});
		}
	};

	useEffect(() => {
		let timer;
		if (thanksModal) {
			timer = setTimeout(() => {
				setThanksModal([false, '']);
			}, 5000);
		}

		// Clear the timer if the component unmounts or showThanksModal changes
		return () => clearTimeout(timer);
	}, [thanksModal]);

	// Coding tools Add this useEffect to handle tab switching
	const [activeTab, setActiveTab] = useState('1');
	// Add new state variables to track drawer states separately
	const [openIcdDrawer, setOpenIcdDrawer] = useState(true);
	const [openCptDrawer, setOpenCptDrawer] = useState(true);

	useEffect(() => {
		if (openIcdCptDrawer2 && activeCode?.type === 'CPT') {
			setActiveTab('2');
		} else {
			setActiveTab('1');
		}
	}, [openIcdCptDrawer2]);

	// Example of handleCodeClick
	const handleCodeClick = (codeType, codeData, flag) => {
		// Check if the code has leading or trailing spaces
		let trimmedCode = codeData.code;

		if (trimmedCode !== trimmedCode.trim()) {
			trimmedCode = trimmedCode.trim();
		}

		// // Check if it's a child code
		// const isChildCode = trimmedCode.includes('.');
		// const parentCode = isChildCode
		// 	? trimmedCode.split('.')[0]
		// 	: trimmedCode;
		setIcdCodes();
		closeIcdCptDrawer(flag);
		setActiveCode({
			type: codeType,
			code: codeData.code,
			description: codeData.description,
			codeTypeText: codeData.codeTypeText,
			buttontext: codeData.buttontext,
		});

		if (codeType === 'CPT') {
			// // Set filters to fetch related codes
			setCptFilters({
				related: true,
				childCode: trimmedCode,
			});
			setCptTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenCptDrawer(false);
			setOpenIcdDrawer(true);
			setActiveTab('2');
		} else {
			// Set filters to fetch related codes
			setIcdFilters({
				related: true,
				childCode: trimmedCode,
			});
			setTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenIcdDrawer(false);
			setOpenCptDrawer(true);
			setActiveTab('1');
		}
	};

	const showIcdCptDrawer = () => {
		setOpenIcdCptDrawer(true);
		setIcdCodes();
		setActiveCode(null);
		setSearchResults();
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptCodes();
		setCptSearchResults();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer = (flag) => {
		if (flag === 'true') {
		} else {
			setOpenIcdCptDrawer(false);
		}
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer2 = () => {
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setOpenIcdCptDrawer2(false);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	useEffect(() => {
		if (getAppealLetterState.apiState === 'success') {
			setAppealLetterLoading(false);
			navigate(`/case/filings/preview/${id}`, {
				state: {
					appealLetterType: typeAppeal,
					patientDetails: patientData,
					content: getAppealLetterState.data.appeal_letter,
					header: getAppealLetterState.data.header,
					footer: getAppealLetterState.data.footer,
					isEdit: false,
				},
			});
		} else if (getAppealLetterState.apiState === 'error') {
			setAppealLetterLoading(false);
			notification.error({
				message: getAppealLetterState.message
					? getAppealLetterState.message
					: 'Unable to get Appeal Letter content',
			});
		}
		getAppealLetterReset();
	}, [getAppealLetterState.apiState]);

	const viewAppealLetter = (regenerate = false) => {
		setAppealLetterLoading(true);
		getAppealLetter({
			id: id,
			type: typeAppeal,
			regenerate_appeal_letter: regenerate,
		});
	};

	const handlePreviewBeforUpload = async (file) => {
		if (file && file.name && file.name.split('.').includes('pdf')) {
			setPreviewImage(file.url || file.preview);
			setPdfPreviewOpen(true);
		} else {
			if (!file.url && !file.preview) {
				file.preview = await getBase64(file.originFileObj);
			}
			setPreviewImage(file.url || file.preview);
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const handleDownload = (file) => {
		// Assuming 'file' contains the URL of the file to download
		window.open(file.url, '_blank');
	};

	const updatePageContent = (title, id, content) => {
		if (id === null) {
			setPageContent({
				...pageContent,
				[title]: [...pageContent[[title]], content],
			});
		} else {
			const updatedPageContent = { ...pageContent };
			updatedPageContent[[title]][id] = content;
			setPageContent(updatedPageContent);
		}
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification')?.classList.remove('d-none');
	};

	const dateOfBirth = (inputDateString) => {
		const date = new Date(inputDateString);

		// Extract the year, month, and day components from the Date object
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // Month is zero-based, so add 1
		const day = date.getDate();

		// Format the date as "MM-DD-YYYY" or any desired format
		return `${month.toString().padStart(2, '0')}-${day
			.toString()
			.padStart(2, '0')}-${year}`;
	};

	function compareGender(patientGender, analysisGender) {
		// Get the first character of the analysisGender string and normalize to uppercase
		const firstCharAnalysis = analysisGender.charAt(0).toUpperCase();

		// Check if patientGender is "M" (Male) or "F" (Female)
		if (
			patientGender?.toUpperCase() === 'MALE' ||
			patientGender?.toUpperCase() === 'FEMALE'
		) {
			// Compare the first character of analysisGender with patientGender
			return firstCharAnalysis === patientGender?.charAt(0).toUpperCase();
		} else {
			// Match patientGender with "O" (Other)
			return firstCharAnalysis === 'O';
		}
	}

	// use effects
	useEffect(() => {
		if (id)
			getAnalysis({
				id: id,
				process_type: pathnameIncludesCaseMA ? null : 'rc',
			});

		getConfigurations({});
	}, [id]);

	// use effects
	useEffect(() => {
		if (id)
			getRevision({
				id: id,
			});
	}, [id]);

	useEffect(() => {
		if (getRevisionState.apiState === 'success') {
			if (getRevisionState.data !== null) {
				setRevisionList(getRevisionState.data);
			}
			getRevisionReset();
		}
	}, [getRevisionState]);

	useEffect(() => {
		if (editCaseState.apiState === 'loading') {
			setUpdateCaseLoading(true);
		}
		if (editCaseState.apiState === 'success') {
			if (sendLetterLoading) {
				setSendLetterLoading(false);
				// navigate(-1);
			}
			setSendLetterLoading(false);
			setCurrentActiveCollapse(null);
			setPrevActiveCollapse(null);
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			setUpdateModalButtonText('Update');
			setUpdateCaseLoading(false);
			// getAnalysis({ id: id });
			if (flag)
				notification.success({
					message: editCaseState.message,
				});
			setModalOpen([false, '']);
			editCaseReset();
			setUpdateModalOpen([false, '']);
			setRevenueCycleStatus('');
			updateForm.setFieldsValue({});
			setRevenueCycleFormData({
				id: id,
				appeal_status: '',
				reimbursed_at: '',
				claim_category: '',
				claim_amount: null,
				status: '',
				denial_reason: '',
				denial_code1: '',
				denial_code2: '',
				revenue_cycle_stage: '',
				is_claim_amount_settled: null,
				claim_amount_updated_at: '',
				appeal_status_updated_at: '',
				revenue_cycle_updates: {
					revenue_cycle_status: '',
					appeal_status: '',
					remarks: '',
					url: [],
				},
			});
			setRevenueCycleStage('');
			updateForm.resetFields();
			setSubmitCase(false);
			setSelectedOption('');
			setFileList([]);
			getRevision({
				id: id,
			});
			if (
				flag &&
				!denialLetterActionPerform &&
				!supportingDocActionPerform
			) {
				getAnalysis({ id: id });
			}
			// navigate(-1);
		}
		setFlag(true);
		if (editCaseState.apiState === 'error') {
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setSendLetterLoading(false);
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			setUpdateModalButtonText('Update');
			setUpdateCaseLoading(false);
			setSubmitCase(false);
			notification.error({
				message: editCaseState.message
					? editCaseState.message
					: 'Unable to update case status, Please try again',
			});
		}
		editCaseReset();
	}, [editCaseState]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'error') {
			setMainDataLoading(false);
		}
		if (getAnalysisState.apiState === 'success') {
			setMainDataLoading(false);
			setShowClinicalTextArea(false);
			if (
				getAnalysisState.data.case_details &&
				getAnalysisState.data.case_details.allocated_to === null
			) {
				notification.error({
					message: 'Case Not Allocated',
					description:
						"Oops! It seems like this case hasn't been allocated to anyone yet. Please allocate it first before proceeding with the analysis.",
				});
			}
			setPatientData(getAnalysisState.data.case_details);

			setPageContent({
				...pageContent,
				originalQuery:
					getAnalysisState.data.coverage_feedback_response[
						'original_query'
					] ?? '-',
				pastHistory:
					getAnalysisState.data.coverage_feedback_response[
						'Past History'
					] ?? [],
				presentComplaint:
					getAnalysisState.data.coverage_feedback_response[
						'Present Complaint'
					] ?? [],
				recommendedProcedure:
					getAnalysisState.data.coverage_feedback_response[
						'Suggested Treatment'
					] ?? [],
				medicalCoverage: [
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Coverage']
						: 'No',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Rationale']
						: '-',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['reference']
						: null,
				],
				missing_points_for_coverage:
					getAnalysisState.data.coverage_feedback_response
						.missing_points_for_coverage ?? [],
				status: getAnalysisState.data.coverage_feedback_response.status,
				ncd_reference:
					getAnalysisState.data.coverage_feedback_response[
						'NCD References'
					] ?? '',
				retired_message:
					getAnalysisState.data.coverage_feedback_response
						.retired_message ?? '',
				is_retired:
					getAnalysisState.data.coverage_feedback_response
						.is_retired ?? 0,
			});
			if (
				getAnalysisState.data.coverage_feedback_response &&
				getAnalysisState.data.coverage_feedback_response.age
			)
				if (
					getAnalysisState.data.coverage_feedback_response &&
					getAnalysisState.data.coverage_feedback_response.gender
				)
					setMatchGender(
						compareGender(
							getAnalysisState.data.case_details.gender,
							getAnalysisState.data.coverage_feedback_response
								.gender,
						),
					);
			setLastAnalysisData(
				getAnalysisState.data?.coverage_feedback_response,
			);

			setFeedbackId(getAnalysisState.data.coverage_feedback_response._id);
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');
			setTimelineData(getAnalysisState.data?.timelineData);
			// Check if the last timeline entry indicates that the case is closed
			const lastTimelineEntry =
				getAnalysisState.data.timelineData?.slice(-1)[0];
			if (
				lastTimelineEntry &&
				(lastTimelineEntry.appeal_status === 'Approved' ||
					lastTimelineEntry.appeal_status === 'Rejected')
			) {
				setCaseClosed(true);
			} else {
				setCaseClosed(false);
			}
			const revenueCycleDocs =
				getAnalysisState.data.case_details
					.revenue_cycle_supporting_documents;

			if (revenueCycleDocs && revenueCycleDocs.length > 0) {
				// Modify fileList to add the prefix to URLs
				const modifiedFileList = revenueCycleDocs.map((file) => ({
					...file,
					url: `${config.s3_url}${file.url}`,
				}));
				setFileList([...modifiedFileList]);
				setSelectedOption('upload');
				setSelectedOption('upload');
			}

			const supportingDocs =
				getAnalysisState.data.case_details.supporting_docs.length > 0 &&
				getAnalysisState.data.case_details.supporting_docs.map(
					(doc) => {
						return doc;
					},
				);
			setDocumentsToDisplay(supportingDocs);

			const clinicalDocs =
				getAnalysisState.data.case_details.clinical_docs.map((doc) => {
					return doc;
				});
			setClinicalDocumentsToDisplay(clinicalDocs);

			const isAnyArrayNotEmpty = Object.keys(pageContent)
				.filter((key) => key !== 'medicalCoverage')
				.some((key) => pageContent[key].length > 0);
		}
	}, [getAnalysisState.apiState]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'success') {
			setShowClinicalTextArea(false);
			const { coverage_feedback_response } = getAnalysisState.data;

			// Check if coverage_feedback_response is empty or if "Medicare Evaluation" is missing or empty
			const isMedicareEvaluationEmpty =
				!coverage_feedback_response?.['Medicare Evaluation'] ||
				Object.keys(coverage_feedback_response['Medicare Evaluation'])
					.length === 0;

			// todo Case analtysis if clinical not thwre
			if (
				!coverage_feedback_response ||
				Object.keys(coverage_feedback_response).length === 0 ||
				isMedicareEvaluationEmpty
			) {
				if (patientData.allocated_to) {
					setLoading(true);
					document
						.getElementById('notification')
						?.classList.add('d-none');
					analyseCoverage({
						clinicalSummary: patientData.clinical_summary,
						case_id: patientData._id,
						state: patientData.state,
						provider: patientData.insurance_company?.name,
						supportingDocsSummary: patientData.summary_docs,
						revenue_cycle: patientData.revenue_cycle,
					});
				}
			}
		}
		getAnalysisReset();
	}, [patientData]);

	useEffect(() => {
		if (showAnalysisData) {
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');
		}
	}, [showAnalysisData]);

	useEffect(() => {
		if (
			analyseCoverageState.apiState == 'success' &&
			id === analyseCoverageState.data?.case_id
		) {
			// Check if original patientData had empty fields and response has them
			if (
				(!patientData.clinical_summary || !patientData.summary_docs) &&
				(analyseCoverageState.data.original_query ||
					analyseCoverageState.data.supportingDocsSummary)
			) {
				// Update patientData with the new summaries
				setPatientData((prevData) => ({
					...prevData,
					clinical_summary:
						analyseCoverageState.data.original_query ||
						prevData.clinical_summary,
					summary_docs:
						analyseCoverageState.data.supportingDocsSummary ||
						prevData.summary_docs,
				}));
			}
			setFeedbackId(analyseCoverageState.data.feedback_id);
			setLastAnalysisData(analyseCoverageState.data);
			setPageContent({
				...pageContent,
				originalQuery:
					analyseCoverageState.data['original_query'] ?? '',
				pastHistory: analyseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					analyseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					analyseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					analyseCoverageState.data.missing_points_for_coverage ?? [],
				ncd_reference:
					analyseCoverageState.data['NCD References'] ?? '',
				retired_message:
					analyseCoverageState.data.retired_message ?? '',
				is_retired: analyseCoverageState.data.is_retired ?? 0,
			});
			setAnalysisCompleted('success');
			analyseCoverageReset();
			if (
				analyseCoverageState.data &&
				analyseCoverageState.data.date_of_birth
			)
				if (
					analyseCoverageState.data &&
					analyseCoverageState.data.gender
				)
					setMatchGender(
						compareGender(
							patientData.gender,
							analyseCoverageState.data.gender,
						),
					);
			if (
				analyseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				analyseCoverageState.data.is_fields_missing &&
				analyseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (analyseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						analyseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						analyseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						analyseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				setIsMissingFieldsThere(false);
				// if (id) getAnalysis({ id: id });
			}
		} else if (analyseCoverageState.apiState === 'error') {
			setShowClinicalTextArea(false);
			setAnalysisCompleted('error');
			setIsMissingFieldsThere(false);
			// setLoading(false);
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			analyseCoverageReset();
		}
	}, [analyseCoverageState]);

	useEffect(() => {
		if (
			reviseCoverageState.apiState == 'success' &&
			id === reviseCoverageState.data?.case_id
		) {
			setShowClinicalTextArea(false);
			setFeedbackId(reviseCoverageState.data.feedback_id);
			setLastAnalysisData(reviseCoverageState.data);
			setPageContent({
				...pageContent,
				originalQuery: reviseCoverageState.data['original_query'] ?? '',
				pastHistory: reviseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					reviseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					reviseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					reviseCoverageState.data.missing_points_for_coverage ?? [],
				status: reviseCoverageState.data.status,
				ncd_reference: reviseCoverageState.data['NCD References'] ?? '',
				retired_message: reviseCoverageState.data.retired_message ?? '',
				is_retired: reviseCoverageState.data.is_retired ?? 0,
			});
			setAnalysisCompleted('success');
			if (reviseCoverageState.data && reviseCoverageState.data.age)
				if (reviseCoverageState.data && reviseCoverageState.data.gender)
					setMatchGender(
						compareGender(
							patientData.gender,
							reviseCoverageState.data.gender,
						),
					);
			if (
				reviseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				reviseCoverageState.data.is_fields_missing &&
				reviseCoverageState.data.hasOwnProperty('missing_fields')
			) {
				if (reviseCoverageState.data.missing_fields.length > 0) {
					setMissingFields(
						reviseCoverageState.data.missing_fields ?? [],
					);
					setMissingFieldInstructions(
						reviseCoverageState.data.missing_field_instructions ??
							[],
					);
					setMissingFieldTitle(
						reviseCoverageState.data.missing_field_title ?? '',
					);
					setMissingFieldsModal(true);
					setIsMissingFieldsThere(true);
				}
			} else {
				setShowAnalysisData(true);
				setIsMissingFieldsThere(false);
				// if (id) getAnalysis({ id: id });
			}
			getRevision({
				id: id,
			});
			// Check if came from batch details and case meets criteria
			if (
				fromBatchDetails &&
				patientData?.batch_status === 'human_intervention' &&
				location?.state?.from
			) {
				// Extract batch ID from the previous URL and navigate back
				const prevPath = location?.state?.from;
				navigate(prevPath);
			}
			reviseCoverageReset();
		} else if (reviseCoverageState.apiState == 'error') {
			setShowClinicalTextArea(false);
			setLoading(false);
			setAnalysisCompleted('error');
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});
			document.getElementById('notification')?.classList.remove('d-none');
		}
	}, [reviseCoverageState.apiState]);

	useEffect(() => {
		if (sendFeedbackState.apiState === 'success') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);
			setModalOpen([false, '', '']);
			if (sendFeedbackState.data === 'negative')
				setThanksModal([true, 'Thanks for making us Better!']);
			else
				setThanksModal([true, 'Case has been analysed and confirmed!']);
			sendFeedbackReset();
			if (id) getAnalysis({ id: id });
		}
		if (sendFeedbackState.apiState === 'error') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);
		}
	}, [sendFeedbackState]);

	useEffect(() => {
		if (getConfigurationsState.apiState === 'success') {
			if (getConfigurationsState.data.all_configurations.length > 0) {
				getConfigurationsState.data.all_configurations.map((option) => {
					if (option.key === 'denial_reason') {
						const optionsList = option.options.map((opt) => ({
							value: opt.value,
							label: opt.label,
						}));
						setDenialReasonData(optionsList);
					}
				});
			}
		}
	}, [getConfigurationsState]);

	const resetFormFields = () => {
		setRevenueCycleFormData({
			...revenueCycleFormData,
			reimbursed_at: '',
			claim_category: '',
			claim_amount: null,
			is_claim_amount_settled: null,
			claim_amount_updated_at: '',
			appeal_status_updated_at: '',
			revenue_cycle_updates: {
				revenue_cycle_status: '',
				appeal_status: '',
				remarks: '',
				url: [],
			},
			denial_reason: '',
			denial_code1: '',
			denial_code2: '',
		});
		setFileList([]);
		updateForm.resetFields([
			'claim_category',
			'claim_amount',
			'is_claim_amount_settled',
			'claim_amount_updated_at',
			'appeal_status_updated_at',
			'remarks',
			'revenue_cycle_supporting_documents',
			'denial_reason',
			'denial_code1',
			'denial_code2',
			'rejected_category',
		]);
		setSelectedOption('');
	};

	// Function to handle changes in the form fields
	const handleInputChange = (e) => {
		const { name, value } = e.target;

		// Update the state based on the field name
		if (name === 'appeal_status') {
			resetFormFields();
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				appeal_status: value,
				revenue_cycle_stage: revenueCycleStage,
				revenue_cycle_updates: {
					appeal_status: value,
					revenue_cycle_status: revenueCycleStage,
				},
				status: value === 'approved' ? 'successful' : 'rejected',
			}));
		} else if (name === 'claim_category') {
			// Update claim_category and claim_amount based on the selected value
			const claimAmount = value === 'full' ? patientData.case_amount : '';
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				claim_category: value,
				claim_amount: claimAmount,
			}));
			// If claim_category is 'full', disable the claim_amount field
			if (value === 'full') {
				updateForm.setFieldsValue({ claim_amount: claimAmount });
			} else {
				updateForm.setFieldsValue({ claim_amount: '' });
			}
		} else if (name === 'claim_amount') {
			// Update claim_amount
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				claim_amount: value,
			}));
		} else if (name === 'remarks') {
			setFileList([]);
			updateForm.resetFields(['revenue_cycle_supporting_documents']);
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				revenue_cycle_stage: revenueCycleStage,
				revenue_cycle_updates: {
					...prevState.revenue_cycle_updates,
					remarks: value,
				},
			}));
		} else if (name === 'is_claim_amount_settled') {
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				is_claim_amount_settled: value,
			}));
		} else if (name === 'denial_code1') {
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				denial_code1: value,
			}));
		} else if (name === 'denial_code2') {
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				denial_code2: value,
			}));
		}
	};

	// Handle changes in the Select component
	const handleSelect = (value, fieldName) => {
		setRevenueCycleFormData((prevState) => ({
			...prevState,
			[fieldName]: value,
		}));
	};

	const handleDateChange = (date, name) => {
		const formattedDate = date
			? date.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
			: null;
		setRevenueCycleFormData((prevState) => ({
			...prevState,
			[name]: formattedDate,
			...(name === 'appeal_status_updated_at' &&
				prevState.appeal_status === 'approved' && {
					claim_amount_updated_at: formattedDate,
				}),
		}));
	};

	const handleChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setFileList(updatedFileList);
		updateForm.validateFields(['revenue_cycle_supporting_documents']);
	};

	const handleSubmit = async () => {
		try {
			if (fileList.length > 0) {
				setUpdateCaseLoading(true);
				setUpdateModalButtonText('Processing Denial Letter');
				await Promise.all(
					fileList.map(async (fileData) => {
						let get_ext = fileData.originFileObj.name.split('.');
						let ext = get_ext[get_ext.length - 1];
						const res = await axios.get(
							`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=case_supporting_documents&file_name=${patientData.patient_last_name}&ext=${ext}&id=${patientData.case_id}`,
							{
								headers: {
									'Content-type':
										'application/json; charset=UTF-8',
									Authorization: 'Bearer ' + getUserToken(),
								},
							},
						);

						const result = await axios.put(
							res.data.data,
							fileData.originFileObj,
						);
						if (result.status === 200) {
							const documentPath = `/case_supporting_documents/${patientData.case_id}/${patientData.patient_last_name}.${ext}`;
							const newFile = {
								uid: fileData.originFileObj.uid,
								name: fileData.originFileObj.name,
								status: 'done',
								url: documentPath,
							};
							setUpdatedFileList((prevFileList) => [newFile]);
						}
					}),
				).then((res) => {
					setUpdateModalButtonText('Processing Denial Letter');
					setSubmitCase(true);
				});
			} else {
				setUpdateModalButtonText('Updating');
				editCase(revenueCycleFormData);
			}
		} catch (error) {
			setUpdateModalButtonText('Update');
			setUpdateCaseLoading(false);
			setSubmitCase(false);
			// Handle error if any
			console.error('Error occurred:', error);
		}
	};

	useEffect(() => {
		if (submitCase) {
			editCase({
				...revenueCycleFormData,
				revenue_cycle_updates: {
					...revenueCycleFormData.revenue_cycle_updates,
					url: updatedFileList,
					revenue_cycle_status:
						revenueCycleFormData.revenue_cycle_stage,
					remarks: null,
				},
			});
		}
	}, [submitCase]);

	useEffect(() => {}, [pageContent]);

	const handleAddOption = (index) => {
		setNewCheckBoxModal([true, index]);
		setNewOptionText('');
		newOptionForm.setFieldsValue({});
		newOptionForm.resetFields();
	};

	const handleNewCheckBoxModal = () => {
		// Create a new option object
		newOptionForm
			.validateFields()
			.then(() => {
				const newOption = {
					label: newOptionText,
					value: newOptionText,
				};

				if (
					newCheckBoxModal[1] !== null &&
					newCheckBoxModal[1] >= 0 &&
					newCheckBoxModal[1] < missingFields.length
				) {
					const updatedFields = [...missingFields];
					updatedFields[newCheckBoxModal[1]].options.push(newOption);
					setMissingFields(updatedFields);

					// Get the current form values
					const currentValues = missingFieldsForm.getFieldsValue();

					// Add the new option to the appropriate field and mark it as checked
					if (
						!currentValues[updatedFields[newCheckBoxModal[1]].name]
					) {
						currentValues[updatedFields[newCheckBoxModal[1]].name] =
							[];
					}
					currentValues[updatedFields[newCheckBoxModal[1]].name].push(
						newOptionText,
					);

					// Update the form with the new values
					missingFieldsForm.setFieldsValue(currentValues);
				}

				// Close the modal and reset the newOptionText state
				setNewCheckBoxModal([false, null]);
				setNewOptionText('');
				newOptionForm.setFieldsValue({});
				newOptionForm.resetFields();
			})
			.catch((info) => {
				console.log('Validate Failed:', info);
			});
	};

	const handleUploadCancel = () => {
		setIsClinicalUploadModalOpen(false);
		setClinicalDocumentFileList([]);
		setUpdatedClinicalDocumentFileList([]);
		setClinicalDocsLoading(false);
		setSubmitClinicalDocs(false);
		clinicalDocsForm.setFieldsValue({ clinical_docs: '' });
	};

	const handleClinicalDocsChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		clinicalDocsForm.validateFields(['clinical_docs']);
	};

	const getTimeAgoOrDate = (updatedAt) => {
		const now = new Date();
		const updateDate = new Date(updatedAt);

		// Check if the updated date is today
		const isToday = now.toDateString() === updateDate.toDateString();

		if (isToday) {
			// Calculate time difference
			const diffInMs = now - updateDate;
			const seconds = Math.floor(diffInMs / 1000);
			const minutes = Math.floor(seconds / 60);
			const hours = Math.floor(minutes / 60);

			if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
			if (minutes > 0)
				return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
			return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
		} else {
			// If not today, return formatted date
			return updateDate.toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
		}
	};

	useEffect(() => {
		if (submitClinicalDocs) {
			editCase({
				id: id,
				clinical_docs: updatedClinicalDocumentFileList,
				upload_documents: true,
				remove: true,
			});
		}
	}, [submitClinicalDocs]);

	useEffect(() => {
		if (missingFieldsModal && missingFieldsCardRef.current) {
			missingFieldsCardRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [missingFieldsModal]);

	// In the useEffect when component mounts, check the previous route
	useEffect(() => {
		// Get previous path from router state
		const prevPath = location?.state?.from;
		if (
			prevPath?.includes('/batch-details/') ||
			prevPath?.includes('/agent-maxx')
		) {
			setFromBatchDetails(true);
		}
	}, [location.state]);

	const [showMobileTimeline, setShowMobileTimeline] = useState(false);
	const [showMobileVHistory, setShowMobileVHistory] = useState(false);

	const showMobileTimelineCard = () => {
		setShowMobileTimeline(true);
	};

	const showMobileVHistoryCard = () => {
		setShowMobileVHistory(true);
	};

	const closeCard = () => {
		setShowMobileTimeline(false);
		setShowMobileVHistory(false);
	};

	const capitalizeFirstLetter = (string) => {
		if (!string) return string; // Return the string if it's null or undefined
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	const [expendProfile, setExpendProfile] = useState(false);
	const handleExpendProfile = () => {
		setExpendProfile(!expendProfile);

		if (expendProfile) {
			document.body.classList.remove('bodyBlockScroll');
		} else {
			document.body.classList.add('bodyBlockScroll');
		}
	};

	const [openVersionLog, setOpenVersionLog] = useState(false);
	const showVersionLog = () => {
		setOpenVersionLog(true);
	};

	const [fullscreenOpen, setFullscreenOpen] = useState(false);
	const triggerRef = useRef(null);

	const handleFullscreenOpen = () => {
		setFullscreenOpen(true);
		document.body.classList.add('hideMinContent');
	};

	const handleFullscreenClose = () => {
		setFullscreenOpen(false);
		document.body.classList.remove('hideMinContent');
	};

	return (
		<>
			{getAnalysisState.apiState === 'error' ? (
				<Page404 />
			) : (
				<>
					{appealLetterLoading && (
						<XLottieOverlay>
							<XLottieLetter
								animationData={AppealLoading}
								loop={true}
							/>
						</XLottieOverlay>
					)}

					{downloadLoading && (
						<XLottieOverlay>
							<XLottieLetter
								animationData={DownloadAnimation}
								loop={true}
							/>
						</XLottieOverlay>
					)}

					{loading && (
						<AnalysisLoader
							analysisId={id}
							analysisCompleted={analysisCompleted}
							setAnalysisCompleted={setAnalysisCompleted}
							setLoading={setLoading}
							isMissingFieldsThere={isMissingFieldsThere}
							loading={loading}
							setIsMissingFieldsThere={setIsMissingFieldsThere}
						/>
					)}

					<XContainer fluid>
						<XAffix
							id="notification"
							className="d-none zIndex"
							offsetTop={80}
						>
							<div className="marginBottomMobile"></div>
							<div
								className="mb-3"
								style={{
									backgroundColor: 'white',
									borderRadius: '20px',
									zIndex: '1111110',
								}}
							>
								<XNotificationBar style={{ zIndex: '22222' }}>
									Clinical Summary has been changed !! Click
									to{' '}
									<XButtonReload
										type="button"
										style={{ padding: '18px' }}
										className="refreshBtn"
										onClick={() => {
											setLoading(true);
											closeIcdCptDrawer();
											closeIcdCptDrawer2();
											document
												.getElementById('notification')
												?.classList.add('d-none');

											reviseCoverageReset();
											// Update lastAnalysisData with the latest pageContent values
											const updatedLastAnalysisData = {
												...lastAnalysisData, // Keep all the existing keys and values intact
												'Past History':
													pageContent.pastHistory, // Update pastHistory
												'Present Complaint':
													pageContent.presentComplaint, // Update presentComplaint
												'Suggested Treatment':
													pageContent.recommendedProcedure, // Update recommendedProcedure
												'Medicare Evaluation': {
													...lastAnalysisData[
														'Medicare Evaluation'
													],
													Coverage:
														pageContent
															.medicalCoverage[0], // Update medicalCoverage fields
													Rationale:
														pageContent
															.medicalCoverage[1],
													reference:
														pageContent
															.medicalCoverage[2],
												},
												original_query:
													pageContent.originalQuery, // Update original_query
												past_history:
													pageContent.pastHistory, // Update past_history in lastAnalysisData
												present_complaint:
													pageContent.presentComplaint, // Update present_complaint in lastAnalysisData
												status: pageContent.status, // Update status in lastAnalysisData
												missing_points_for_coverage:
													pageContent.missing_points_for_coverage, // Update missing_points_for_coverage
												// Add other updates if necessary, or keep them unchanged
											};
											reviseCoverage({
												case_id: patientData._id,
												feedbackId: feedbackId,
												clinicalHistory:
													pageContent.pastHistory,
												presentComplaint:
													pageContent.presentComplaint,
												recommendedProcedure:
													pageContent.recommendedProcedure,
												medicalCoverage:
													pageContent.medicalCoverage,
												state: patientData.state,
												provider:
													patientData
														.insurance_company
														?.name,
												last_analysis_data:
													updatedLastAnalysisData,
												supportingDocsSummary:
													patientData &&
													patientData.summary_docs,
												revenue_cycle:
													patientData.revenue_cycle,
											});
										}}
									>
										Reanalyse it !!
									</XButtonReload>
									<XButtonCloseBar
										type="button"
										className="closeBar mt-3"
									>
										<CloseOutlined
											onClick={() => {
												document
													.getElementById(
														'notification',
													)
													?.classList.add('d-none');
											}}
											style={{ fontSize: '20px' }}
										/>
									</XButtonCloseBar>
								</XNotificationBar>
							</div>
							<div className="marginNone"></div>
						</XAffix>
					</XContainer>
					{props.displayHeader ? (
						<></>
					) : (
						<>
							<Col lg={24} xl={24} xs={0} md={0}>
								<Header
									headerTag="Case Filings"
									breadcrumb="true"
									caseId={patientData.case_id}
									versionNumber={versionNumber}
								/>
							</Col>
							<Col lg={0} xl={0} xs={24} md={24}>
								<HeaderFile activeNav="casefiling" />
							</Col>
						</>
					)}

					<XThemeContainer fluid>
						{checkModulePermissions(
							'ma-plan-appeals-processing',
						).sub_modules.includes('view-case') ||
						checkModulePermissions(
							'case-filing',
						).sub_modules.includes('view-case') ? (
							<>
								<Row gutter={(15, 15)}>
									{mainDataLoading ? (
										<>
											<Skeleton
												active
												paragraph={{
													rows: 8,
												}}
											/>
										</>
									) : (
										<>
											<Col xs={24}>
												<XThemeMobileCaseDetailsHeader className="mb-3">
													<Row gutter={(15, 15)}>
														<Col xs={12}>
															<XThemMainTitle>
																{
																	patientData.case_id
																}
																<br />
																<span>
																	Case Filings
																	/{' '}
																	{
																		patientData.mrn
																	}
																</span>
															</XThemMainTitle>
														</Col>
														<Col
															xs={12}
															className="text-end"
														>
															<div className="timelineVHistoryWrap">
																<XThemeFilterCircleButton
																	shape="circle"
																	size="large"
																	className="grayBackground me-2"
																	icon={
																		<img
																			src="/images/timeline-mob.svg"
																			alt="filter"
																		/>
																	}
																	onClick={() => {
																		showMobileTimelineCard();
																	}}
																/>
																<XThemeFilterCircleButton
																	shape="circle"
																	size="large"
																	className="grayBackground"
																	icon={
																		<img
																			src="/images/reload-mob.svg"
																			alt="filter"
																		/>
																	}
																	onClick={() => {
																		showMobileVHistoryCard();
																	}}
																/>
															</div>

															{showMobileTimeline && (
																<XThemeMobileTimeVHistoryWrapper
																	// title="Case Timeline"
																	title={
																		<Space align="center">
																			{!togglePrepareLetter ? (
																				'Case Timeline'
																			) : (
																				<>
																					<XButtonBack
																						onClick={() =>
																							setTogglePrepareLetter(
																								false,
																							)
																						}
																						icon={
																							<ArrowLeftOutlined />
																						}
																						size="large"
																					/>
																					Prepare
																					Letter
																				</>
																			)}
																		</Space>
																	}
																	extra={
																		<XThemeFilterCircleButton
																			shape="circle"
																			size="large"
																			className="grayBackground"
																			icon={
																				<CloseOutlined />
																			}
																			onClick={() => {
																				closeCard();
																			}}
																		/>
																	}
																>
																	<div
																		className={`toggle ${
																			!togglePrepareLetter
																				? 'rotated'
																				: ''
																		}`}
																	>
																		<div className="front">
																			{togglePrepareLetter && (
																				<>
																					<XThemeAffixCard>
																						<PrepareLetter
																							denialLetterActionPerform={
																								denialLetterActionPerform
																							}
																							setDenialLetterActionPerform={
																								setDenialLetterActionPerform
																							}
																							setSupportingDocActionPerform={
																								setSupportingDocActionPerform
																							}
																							setParentDocumentsToDisplay={
																								setDocumentsToDisplay
																							}
																							setParentPatientData={
																								setPatientData
																							}
																							approveModalOpen={
																								approveModalOpen
																							}
																							revenueCycle={
																								patientData.revenue_cycle
																							}
																							setTogglePrepareLetter={
																								setTogglePrepareLetter
																							}
																							setLoading={
																								setAppealLetterLoading
																							}
																							setDownloadLoading={
																								setDownloadLoading
																							}
																							setApproveModalOpen={
																								setApproveModalOpen
																							}
																							setTypeAppeal={
																								setTypeAppeal
																							}
																						/>
																					</XThemeAffixCard>
																				</>
																			)}
																		</div>
																		<div className="back">
																			{!togglePrepareLetter && (
																				<XThemeAffixCard>
																					{/* new code */}
																					<>
																						{mainDataLoading ? (
																							<>
																								<Skeleton
																									active
																									paragraph={{
																										rows: 6,
																									}}
																								/>
																							</>
																						) : (
																							<>
																								{timelineData &&
																								timelineData.length >
																									0 ? (
																									<Timeline
																										setCurrentActiveCollapse={
																											setCurrentActiveCollapse
																										}
																										setPrevActiveCollapse={
																											setPrevActiveCollapse
																										}
																										prevActiveCollapse={
																											prevActiveCollapse
																										}
																										currentActiveCollapse={
																											currentActiveCollapse
																										}
																										handlePreviewBeforUploa
																										d={
																											handlePreviewBeforUpload
																										}
																										handleChange={
																											handleChange
																										}
																										handleDownload={
																											handleDownload
																										}
																										selectedOption={
																											selectedOption
																										}
																										filterByLabel={
																											filterByLabel
																										}
																										denialReasonData={
																											denialReasonData
																										}
																										handleSelect={
																											handleSelect
																										}
																										handleDateChange={
																											handleDateChange
																										}
																										disableFutureDates={
																											disableFutureDates
																										}
																										updateModalOpen={
																											updateModalOpen
																										}
																										updateForm={
																											updateForm
																										}
																										handleSubmit={
																											handleSubmit
																										}
																										patientData={
																											patientData
																										}
																										handleInputChange={
																											handleInputChange
																										}
																										setApproveModalOpen={
																											setApproveModalOpen
																										}
																										revenueCycleStatus={
																											revenueCycleStatus
																										}
																										setRevenueCycleStage={
																											setRevenueCycleStage
																										}
																										revenueCycleStage={
																											revenueCycleStage
																										}
																										status={
																											formData?.status
																										}
																										setUpdateModalOpen={
																											setUpdateModalOpen
																										}
																										setRevenueCycleStatus={
																											setRevenueCycleStatus
																										}
																										revenueCycleFormData={
																											revenueCycleFormData
																										}
																										setRevenueCycleFormData={
																											setRevenueCycleFormData
																										}
																										timelineData={
																											timelineData
																										}
																										togglePrepareLetter={
																											togglePrepareLetter
																										}
																										setTogglePrepareLetter={
																											setTogglePrepareLetter
																										}
																										fileList={
																											fileList
																										}
																										setFileList={
																											setFileList
																										}
																										setUpdatedFileList={
																											setUpdatedFileList
																										}
																										updatedFileList={
																											updatedFileList
																										}
																										id={
																											id
																										}
																										setSelectedOption={
																											setSelectedOption
																										}
																										medicareCoverage={
																											pageContent
																												.medicalCoverage[0]
																										}
																										case_status={
																											patientData.status
																										}
																										setFlag={
																											setFlag
																										}
																										setDownloadLoading={
																											setDownloadLoading
																										}
																										updateModalButtonText={
																											updateModalButtonText
																										}
																										updateCaseLoading={
																											updateCaseLoading
																										}
																										viewAppealLetter={
																											viewAppealLetter
																										}
																									/>
																								) : (
																									<>

																									</>
																								)}
																							</>
																						)}
																					</>
																				</XThemeAffixCard>
																			)}
																		</div>
																	</div>
																</XThemeMobileTimeVHistoryWrapper>
															)}
															{showMobileVHistory && (
																<XThemeMobileTimeVHistoryWrapper
																	title="Version History"
																	extra={
																		<XThemeFilterCircleButton
																			shape="circle"
																			size="large"
																			className="grayBackground"
																			icon={
																				<CloseOutlined />
																			}
																			onClick={() => {
																				closeCard();
																			}}
																		/>
																	}
																>
																	<>
																		{revisionList?.length >
																		0 ? (
																			revisionList.flatMap(
																				(
																					revision,
																					i,
																				) =>
																					revision.changes.map(
																						(
																							change,
																							index,
																						) => {
																							// Render each change here
																							return (
																								<XThemeCardBackBgVersion
																									className={`mb-3 ${
																										currentRevision?._id ===
																										change._id
																											? 'activeBg'
																											: ''
																									}`}
																								>
																									<Row
																										gutter={
																											(15,
																											15)
																										}
																										className="align-items-center"
																									>
																										<Col
																											xl={
																												3
																											}
																											xs={
																												3
																											}
																										>
																											<RevisionHistoryNum
																												style={{
																													backgroundColor:
																														currentRevision?._id &&
																														currentRevision?._id.toString() ===
																															change._id.toString()
																															? '#007299'
																															: '',
																												}}
																											>
																												<span
																													style={{
																														color:
																															currentRevision?._id &&
																															currentRevision?._id.toString() ===
																																change._id.toString()
																																? ''
																																: '#007299',
																													}}
																													class="RevisionNum"
																												>
																													v
																													{
																														revision.revisionNumber
																													}

																													.
																													{revision
																														.changes
																														.length -
																														index}
																												</span>
																											</RevisionHistoryNum>
																										</Col>
																										<Col
																											xs={
																												16
																											}
																										>
																											<>
																												<RevisionHisTitle>
																													Edited{' '}
																													{
																														change.name
																													}
																													<div className="revisionHisIcons">
																														{getTimeAgoOrDate(
																															revision.updatedAt,
																														)}
																													</div>
																												</RevisionHisTitle>
																											</>
																										</Col>
																										{currentRevision?._id &&
																										currentRevision?._id.toString() ===
																											change._id.toString() ? null : i ===
																												0 &&
																										  index ===
																												0 ? (
																											<Col
																												xs={
																													5
																												}
																												className="text-center"
																											>
																												<CurrentRevision
																													role="button"
																													onClick={() => {
																														setVersionNumber(
																															`v${
																																revision.revisionNumber
																															}.${
																																revision
																																	.changes
																																	.length -
																																index
																															}`,
																														);
																														setCurrentRevision(
																															change,
																														);
																													}}
																												>
																													Current
																												</CurrentRevision>
																											</Col>
																										) : (
																											<Col
																												xs={
																													5
																												}
																												className="text-end"
																											>
																												<EyeIcon
																													onClick={() => {
																														setVersionNumber(
																															`v${
																																revision.revisionNumber
																															}.${
																																revision
																																	.changes
																																	.length -
																																index
																															}`,
																														);
																														setCurrentRevision(
																															change,
																														);
																													}}
																												>
																													<EyeOutlined />
																												</EyeIcon>
																											</Col>
																										)}
																									</Row>
																								</XThemeCardBackBgVersion>
																							);
																						},
																					),
																			)
																		) : (
																			<div
																				style={{
																					textAlign:
																						'center',
																					padding:
																						'20px',
																					color: '#555',
																				}}
																			>
																				No
																				revision
																				history
																				available
																			</div>
																		)}
																	</>
																</XThemeMobileTimeVHistoryWrapper>
															)}
														</Col>
													</Row>
												</XThemeMobileCaseDetailsHeader>
											</Col>

											<Col xs={24}>
												<Row
													gutter={[15, 15]}
													className="mb-3"
												>
													<Col xs={24} lg={12}>
														<XThemeCardCaseOperations
															title={
																<div className="customWidthHeaderWrap">
																	<div className="customWidthHeadIcon">
																		<XThemeAvatarName
																			size={
																				50
																			}
																		>
																			{patientData.patient_first_name &&
																				patientData
																					?.patient_first_name[0]}
																			{patientData.patient_last_name &&
																				patientData
																					?.patient_last_name[0]}
																			{/* {patientData.patient_first_name[0]}
																			{patientData.patient_last_name[0]} */}
																		</XThemeAvatarName>
																	</div>
																	<div className="customWidthHeader">
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				span={
																					20
																				}
																			>
																				<XTheme2MainTitle2
																					style={{
																						color:
																							currentRevision?.field ===
																								'patient_first_name' ||
																							currentRevision?.field ===
																								'patient_last_name'
																								? '#007299'
																								: '',
																						// backgroundColor:
																						// 	currentRevision?.field ===
																						// 		'patient_first_name' ||
																						// 	currentRevision?.field ===
																						// 		'patient_last_name'
																						// 		? 'rgba(223,235,240,0.5)'
																						// 		: '',
																					}}
																				>
																					{currentRevision?.field ===
																					'patient_first_name'
																						? `${
																								currentRevision?.newValue
																						  }${' '}${
																								patientData.patient_last_name &&
																								patientData?.patient_last_name
																						  }`
																						: currentRevision?.field ===
																						  'patient_last_name'
																						? `${
																								patientData.patient_first_name &&
																								patientData?.patient_first_name
																						  }${
																								currentRevision?.newValue
																						  }`
																						: patientData.patient_name}
																				</XTheme2MainTitle2>

																				<XTheme2TableCircleTag
																					className={
																						patientData.status
																					}
																				>
																					{toTitleCase(
																						patientData.status,
																					)}{' '}
																				</XTheme2TableCircleTag>
																				{patientData.status ===
																				'letter_sent' ? (
																					<XTheme2TableCircleTag
																						className={
																							patientData.status
																						}
																					>
																						{toTitleCase(
																							patientData.status,
																						)}
																					</XTheme2TableCircleTag>
																				) : (
																					''
																				)}
																				<XThemeAvatarText>
																					DOB:{' '}
																					<span
																						className={
																							currentRevision?.field ===
																							'date_of_birth'
																								? 'highlight'
																								: ''
																						}
																					>
																						{currentRevision?.field ===
																						'date_of_birth'
																							? dateOfBirth(
																									currentRevision?.newValue,
																							  )
																							: patientData.date_of_birth
																							? dateOfBirth(
																									patientData.date_of_birth,
																							  )
																							: ''}
																					</span>
																					<span
																						className={
																							currentRevision?.field ===
																							'gender'
																								? 'highlight'
																								: 'me-0'
																						}
																					>
																						&#128900;{' '}
																						{currentRevision?.field ===
																						'gender'
																							? toTitleCase(
																									currentRevision?.newValue,
																							  )
																							: patientData.gender
																							? toTitleCase(
																									patientData.gender,
																							  )
																							: ''}
																						&nbsp;
																						{matchGender ? (
																							<>
																								{' '}
																							</>
																						) : (
																							<Tooltip
																								title="The gender of the patient does not correspond with the gender entered in the Clinical Summary."
																								trigger={
																									'hover'
																								}
																							>
																								<WarningOutlined
																									style={{
																										color: 'red',
																									}}
																								/>
																							</Tooltip>
																						)}
																					</span>
																					&#128900;
																				</XThemeAvatarText>
																			</Col>
																			<Col
																				span={
																					4
																				}
																				className="text-end"
																			>
																				<Tooltip
																					title="Expand"
																					color={
																						Theme
																							.CQColors
																							.secondaryColor
																					}
																				>
																					<XButtonConfirm
																						size="middle"
																						shape="circle"
																						ref={
																							triggerRef
																						}
																						layoutId="morphingModal"
																						className="motionOpenBtn"
																						onClick={
																							handleFullscreenOpen
																						}
																						icon={
																							<ArrowsAltOutlined />
																						}
																					/>
																				</Tooltip>
																			</Col>
																		</Row>
																	</div>
																</div>
															}
														>
															<XThemeAddressWrap
																className="noPadding"
																// className={
																// 	expendProfile
																// 		? 'noPadding'
																// 		: 'noPadding cardHeight'
																// }
															>
																<XThemeMotionMode>
																	<AnimatePresence mode="wait">
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-1.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Revenue
																						Cycle
																						Stage
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'revenue_cycle_stage'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'organization_determination' &&
																								  'Organization Determination'
																								: patientData.revenue_cycle_stage ===
																										'organization_determination' &&
																								  'Organization Determination'}
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'first_appeal' &&
																								  'First Appeal'
																								: patientData.revenue_cycle_stage ===
																										'first_appeal' &&
																								  'First Appeal'}
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'second_appeal' &&
																								  'Second Appeal'
																								: patientData.revenue_cycle_stage ===
																										'second_appeal' &&
																								  'Second Appeal'}
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'third_appeal' &&
																								  'Third Appeal'
																								: patientData.revenue_cycle_stage ===
																										'third_appeal' &&
																								  'Third Appeal'}
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'fourth_appeal' &&
																								  'Fourth Appeal'
																								: patientData.revenue_cycle_stage ===
																										'fourth_appeal' &&
																								  'Fourth Appeal'}
																							{currentRevision?.field ===
																							'revenue_cycle_stage'
																								? currentRevision?.newValue ===
																										'judicial_review' &&
																								  'Judicial Review'
																								: patientData.revenue_cycle_stage ===
																										'judicial_review' &&
																								  'Judicial Review'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-2.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						State
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'state'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'state'
																								? currentRevision?.newValue
																								: patientData.state}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-4.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Organization
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'organization'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'organization'
																								? currentRevision
																										?.newValue
																										?.name
																								: patientData
																										.organization
																										?.name ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-5.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Hospital
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'hospital'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'hospital'
																								? currentRevision
																										?.newValue
																										?.name
																								: patientData
																										.hospital
																										?.name ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-6.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Insurance
																						Claim
																						Number{' '}
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'insurance_claim_number'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'insurance_claim_number'
																								? currentRevision?.newValue
																								: patientData?.insurance_claim_number ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-7.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Insurance
																						Company
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'insurance_company'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'insurance_company'
																								? currentRevision
																										?.newValue
																										?.name
																								: patientData
																										.insurance_company
																										?.name ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-8.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Region
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'region'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'region'
																								? currentRevision
																										?.newValue
																										?.name
																								: patientData
																										.region
																										?.name ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-9.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Claim
																						Amount
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'claim_amount'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'claim_amount'
																								? `$${currentRevision?.newValue}`
																								: patientData.claim_amount
																								? `$${patientData.claim_amount}`
																								: '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<img
																							src="/images/prof-9.svg"
																							alt=""
																						/>
																					</div>
																					<div className="heading mb-0">
																						Case
																						Amount
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'case_amount'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'case_amount'
																								? `$${currentRevision?.newValue}`
																								: patientData.case_amount
																								? `$${patientData.case_amount}`
																								: '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																			<Col
																				xs={
																					24
																				}
																				lg={
																					12
																				}
																			>
																				<Space className="align-items-center">
																					<div className="iconWrapper">
																						<UserOutlined />
																					</div>
																					<div className="heading mb-0">
																						Allocated
																						to
																						<br />
																						<span
																							className={
																								currentRevision?.field ===
																								'allocated_to'
																									? 'highlight'
																									: ''
																							}
																						>
																							{currentRevision?.field ===
																							'allocated_to'
																								? currentRevision
																										?.newValue
																										?.name
																								: patientData
																										.allocated_to
																										?.name ??
																								  '-'}
																						</span>
																					</div>
																				</Space>
																			</Col>
																		</Row>
																		{fullscreenOpen && (
																			<div
																				className="motionAnimateWrapper"
																				style={{
																					marginLeft:
																						window.innerWidth <=
																						991
																							? 0
																							: props.collapsed
																							? 80
																							: 210,
																					width:
																						window.innerWidth <=
																						991
																							? '100%'
																							: props.collapsed
																							? 'calc(100% - 80px)'
																							: 'calc(100% - 210px)',
																				}}
																			>
																				{/* Backdrop - covers the entire main content area */}
																				<motion.div
																					className="motionBackdrop"
																					onClick={
																						handleFullscreenClose
																					}
																				/>
																				{/* Modal Content - morphs from the trigger div */}
																				<motion.div
																					layoutId="morphingModal"
																					initial={{
																						opacity: 0,
																						scale: 0,
																					}}
																					animate={{
																						opacity: 1,
																						scale: 1,
																					}}
																					exit={{
																						opacity: 0,
																						scale: 0,
																					}}
																					className="motionContent"
																				>
																					{/* Close button */}
																					<XTheme2Button
																						icon={
																							<CloseOutlined />
																						}
																						onClick={
																							handleFullscreenClose
																						}
																						size="large"
																						shape="circle"
																						className="motionCloseBtn"
																					/>
																					<Row
																						gutter={[
																							15,
																							15,
																						]}
																						className="align-items-center mb-3"
																					>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-1.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Revenue
																									Cycle
																									Stage
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'revenue_cycle_stage'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'organization_determination' &&
																											  'Organization Determination'
																											: patientData.revenue_cycle_stage ===
																													'organization_determination' &&
																											  'Organization Determination'}
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'first_appeal' &&
																											  'First Appeal'
																											: patientData.revenue_cycle_stage ===
																													'first_appeal' &&
																											  'First Appeal'}
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'second_appeal' &&
																											  'Second Appeal'
																											: patientData.revenue_cycle_stage ===
																													'second_appeal' &&
																											  'Second Appeal'}
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'third_appeal' &&
																											  'Third Appeal'
																											: patientData.revenue_cycle_stage ===
																													'third_appeal' &&
																											  'Third Appeal'}
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'fourth_appeal' &&
																											  'Fourth Appeal'
																											: patientData.revenue_cycle_stage ===
																													'fourth_appeal' &&
																											  'Fourth Appeal'}
																										{currentRevision?.field ===
																										'revenue_cycle_stage'
																											? currentRevision?.newValue ===
																													'judicial_review' &&
																											  'Judicial Review'
																											: patientData.revenue_cycle_stage ===
																													'judicial_review' &&
																											  'Judicial Review'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-2.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									State
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'state'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'state'
																											? currentRevision?.newValue
																											: patientData.state}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-4.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Organization
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'organization'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'organization'
																											? currentRevision
																													?.newValue
																													?.name
																											: patientData
																													.organization
																													?.name ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-5.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Hospital
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'hospital'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'hospital'
																											? currentRevision
																													?.newValue
																													?.name
																											: patientData
																													.hospital
																													?.name ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-6.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Insurance
																									Claim
																									Number{' '}
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'insurance_claim_number'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'insurance_claim_number'
																											? currentRevision?.newValue
																											: patientData?.insurance_claim_number ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-7.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Insurance
																									Company
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'insurance_company'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'insurance_company'
																											? currentRevision
																													?.newValue
																													?.name
																											: patientData
																													.insurance_company
																													?.name ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-8.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Region
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'region'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'region'
																											? currentRevision
																													?.newValue
																													?.name
																											: patientData
																													.region
																													?.name ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-9.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Claim
																									Amount
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'claim_amount'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'claim_amount'
																											? `$${currentRevision?.newValue}`
																											: patientData.claim_amount
																											? `$${patientData.claim_amount}`
																											: '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-9.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Case
																									Amount
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'case_amount'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'case_amount'
																											? `$${currentRevision?.newValue}`
																											: patientData.case_amount
																											? `$${patientData.case_amount}`
																											: '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<UserOutlined />
																								</div>
																								<div className="heading mb-0">
																									Allocated
																									to
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'allocated_to'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'allocated_to'
																											? currentRevision
																													?.newValue
																													?.name
																											: patientData
																													.allocated_to
																													?.name ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-1.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Revenue
																									Cycle
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'revenue_cycle'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'revenue_cycle'
																											? currentRevision?.newValue ===
																													'pre_service' &&
																											  'Pre Service'
																											: patientData.revenue_cycle ===
																													'pre_service' &&
																											  'Pre Service'}
																										{currentRevision?.field ===
																										'revenue_cycle'
																											? currentRevision?.newValue ===
																													'post_claim' &&
																											  'Post Claim'
																											: patientData.revenue_cycle ===
																													'post_claim' &&
																											  'Post Claim'}
																										{currentRevision?.field ===
																										'revenue_cycle'
																											? currentRevision?.newValue ===
																													'part_b_drugs' &&
																											  'Part B Drugs'
																											: patientData.revenue_cycle ===
																													'part_b_drugs' &&
																											  'Part B Drugs'}
																										{currentRevision?.field ===
																										'revenue_cycle'
																											? currentRevision?.newValue ===
																													'pre_service_part_c' &&
																											  'Pre Service Part C'
																											: patientData.revenue_cycle ===
																													'pre_service_part_c' &&
																											  'Pre Service Part C'}
																										{currentRevision?.field ===
																										'revenue_cycle'
																											? currentRevision?.newValue ===
																													'post_claim_part_c' &&
																											  'Post Claim Part C'
																											: patientData.revenue_cycle ===
																													'post_claim_part_c' &&
																											  'Post Claim Part C'}
																									</span>
																								</div>
																							</Space>
																						</Col>

																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-10.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Providers
																									Encounter
																									Number{' '}
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'providers_encounter_number'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'providers_encounter_number'
																											? currentRevision?.newValue
																											: patientData?.providers_encounter_number ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-11.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Discharge
																									Date
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'date_of_discharge'
																												? 'highlight'
																												: ''
																										}
																									>
																										{/* {patientData.date_of_discharge ?? '-'} */}
																										{currentRevision?.field ===
																										'date_of_discharge'
																											? dateOfBirth(
																													currentRevision?.newValue,
																											  )
																											: patientData.date_of_discharge
																											? dateOfBirth(
																													patientData.date_of_discharge,
																											  )
																											: ''}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-11.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Hearing
																									Date
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'hearing_date'
																												? 'highlight'
																												: ''
																										}
																									>
																										{/* {patientData.hearing_date ?? '-'} */}
																										{currentRevision?.field ===
																										'hearing_date'
																											? dateOfBirth(
																													currentRevision?.newValue,
																											  )
																											: patientData.hearing_date
																											? dateOfBirth(
																													patientData.hearing_date,
																											  )
																											: ''}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-11.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Admission
																									Date
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'date_of_admission'
																												? 'highlight'
																												: ''
																										}
																									>
																										{/* {patientData.date_of_admission ?? '-'} */}
																										{currentRevision?.field ===
																										'date_of_admission'
																											? dateOfBirth(
																													currentRevision?.newValue,
																											  )
																											: patientData.date_of_admission
																											? dateOfBirth(
																													patientData.date_of_admission,
																											  )
																											: ''}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-11.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									EOB
																									Date
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'date_of_eob'
																												? 'highlight'
																												: ''
																										}
																									>
																										{/* {patientData.date_of_eob ?? '-'} */}
																										{currentRevision?.field ===
																										'date_of_eob'
																											? dateOfBirth(
																													currentRevision?.newValue,
																											  )
																											: patientData.date_of_eob
																											? dateOfBirth(
																													patientData.date_of_eob,
																											  )
																											: ''}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-1.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Process
																									Type
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'process_type'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'process_type'
																											? currentRevision?.newValue ===
																													'ma_standard' &&
																											  'MA Standard Appeal Turn-Around-Time (TAT)'
																											: patientData.process_type ===
																													'ma_standard' &&
																											  'MA Standard Appeal Turn-Around-Time (TAT)'}
																										{currentRevision?.field ===
																										'process_type'
																											? currentRevision?.newValue ===
																													'ma_expedited' &&
																											  'MA Expedited Appeal Turn-Around-Time (TAT)'
																											: patientData.process_type ===
																													'ma_expedited' &&
																											  'MA Expedited Appeal Turn-Around-Time (TAT)'}
																										{/* {currentRevision?.field ===
																		'process_type'
																			? currentRevision?.newValue
																			: patientData.process_type ?? '-'} */}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-12.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Visit
																									Type
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'visit_type'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'visit_type'
																											? currentRevision?.newValue
																											: patientData.visit_type ??
																											  '-'}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						{/* status */}
																						<Col
																							xs={
																								24
																							}
																							sm={
																								12
																							}
																							lg={
																								8
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-13.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Status
																									<br />
																									<span
																										className={
																											currentRevision?.field ===
																											'status'
																												? 'highlight'
																												: ''
																										}
																									>
																										{currentRevision?.field ===
																										'status'
																											? capitalizeFirstLetter(
																													currentRevision?.newValue,
																											  )
																											: capitalizeFirstLetter(
																													patientData.status ??
																														'-',
																											  )}
																									</span>
																								</div>
																							</Space>
																						</Col>
																						{/* New Date of Service Column */}
																						<Col
																							xs={
																								24
																							}
																						>
																							<Space className="align-items-center">
																								<div className="iconWrapper">
																									<img
																										src="/images/prof-11.svg"
																										alt=""
																									/>
																								</div>
																								<div className="heading mb-0">
																									Date
																									of
																									Service{' '}
																									<br />
																									<div
																										style={{
																											display:
																												'flex',
																											flexWrap:
																												'wrap',
																										}}
																									>
																										{/* Display single dates if available */}
																										{currentRevision?.field !==
																											'date_of_service' &&
																											patientData
																												.date_of_service
																												?.single_date
																												?.length >
																												0 && (
																												<>
																													{patientData.date_of_service.single_date.map(
																														(
																															date,
																															index,
																														) => (
																															<span
																																key={
																																	index
																																}
																															>
																																{dayjs(
																																	date,
																																).format(
																																	'MM-DD-YYYY',
																																)}
																																{
																																	index <
																																		patientData
																																			.date_of_service
																																			.single_date
																																			.length -
																																			1 && (
																																		<span>
																																			,&nbsp;
																																		</span>
																																	)
																																	// ', '
																																}
																															</span>
																														),
																													)}
																												</>
																											)}
																										{currentRevision?.field ===
																											'date_of_service' &&
																											currentRevision
																												?.newValue
																												?.single_date
																												?.length >
																												0 && (
																												<>
																													{currentRevision?.newValue?.single_date.map(
																														(
																															date,
																															index,
																														) => (
																															<span
																																className="highlight"
																																key={
																																	index
																																}
																															>
																																{dayjs(
																																	date,
																																).format(
																																	'MM-DD-YYYY',
																																)}
																																{
																																	index <
																																		currentRevision
																																			.newValue
																																			.single_date
																																			.length -
																																			1 && (
																																		<span>
																																			,&nbsp;
																																		</span>
																																	)
																																	// ', '
																																}
																															</span>
																														),
																													)}
																												</>
																											)}
																										{/* Display a separator if both single dates and date ranges exist */}
																										{
																											currentRevision?.field !==
																												'date_of_service' &&
																												patientData
																													.date_of_service
																													?.single_date
																													?.length >
																													0 &&
																												patientData
																													.date_of_service
																													?.date_range
																													?.length >
																													0 && (
																													<span>
																														,&nbsp;
																													</span>
																												)
																											// ', '
																										}
																										{
																											currentRevision?.field ===
																												'date_of_service' &&
																												currentRevision
																													?.newValue
																													?.single_date
																													?.length >
																													0 &&
																												currentRevision
																													?.newValue
																													?.date_range
																													?.length >
																													0 && (
																													<span>
																														,&nbsp;
																													</span>
																												)
																											// ', '
																										}
																										{/* Display date ranges if available */}
																										{currentRevision?.field !==
																											'date_of_service' &&
																											patientData
																												.date_of_service
																												?.date_range
																												?.length >
																												0 && (
																												<>
																													{patientData.date_of_service.date_range.map(
																														(
																															range,
																															index,
																														) => (
																															<span
																																key={
																																	index
																																}
																															>
																																{range[0]
																																	? dayjs(
																																			range[0],
																																	  ).format(
																																			'MM-DD-YYYY',
																																	  )
																																	: ''}
																																{
																																	' to '
																																}
																																{range[1]
																																	? dayjs(
																																			range[1],
																																	  ).format(
																																			'MM-DD-YYYY',
																																	  )
																																	: ''}
																																{index <
																																	patientData
																																		.date_of_service
																																		.date_range
																																		.length -
																																		1 && (
																																	<span>
																																		,&nbsp;
																																	</span>
																																)}
																															</span>
																														),
																													)}
																												</>
																											)}
																										{currentRevision?.field ===
																											'date_of_service' &&
																											currentRevision
																												?.newValue
																												?.date_range
																												?.length >
																												0 && (
																												<>
																													{currentRevision?.newValue?.date_range.map(
																														(
																															range,
																															index,
																														) => (
																															<span
																																className="highlight"
																																key={
																																	index
																																}
																															>
																																{range[0]
																																	? dayjs(
																																			range[0],
																																	  ).format(
																																			'MM-DD-YYYY',
																																	  )
																																	: ''}
																																{
																																	' to '
																																}
																																{range[1]
																																	? dayjs(
																																			range[1],
																																	  ).format(
																																			'MM-DD-YYYY',
																																	  )
																																	: ''}
																																{
																																	index <
																																		currentRevision
																																			.newValue
																																			.date_range
																																			.length -
																																			1 && (
																																		<span>
																																			,&nbsp;
																																		</span>
																																	)
																																	// ', '
																																}
																															</span>
																														),
																													)}
																												</>
																											)}
																										{/* Placeholder if no dates are selected */}
																										{!(
																											patientData
																												.date_of_service
																												?.single_date
																												?.length >
																												0 ||
																											patientData
																												.date_of_service
																												?.date_range
																												?.length >
																												0
																										) &&
																											'-'}
																									</div>
																								</div>
																							</Space>
																						</Col>
																					</Row>
																				</motion.div>
																			</div>
																		)}
																	</AnimatePresence>
																</XThemeMotionMode>
															</XThemeAddressWrap>
														</XThemeCardCaseOperations>
													</Col>
													<Col xs={24} lg={12}>
														{/* offsetTop={affixTop} */}
														<>
															<>
																{/* new code add start */}

																{/* new code add end */}
																{/* Case TImeline and Prepare Letter */}
																{/* <div
																	className={`toggle ${
																		!togglePrepareLetter
																			? 'rotated'
																			: ''
																	}`}
																>
																	<div className="front">
																		{togglePrepareLetter && ( */}
																<>
																	{/* Prepare Letter Drawer */}
																	<Drawer
																		title={
																			<Space align="center">
																				<XButtonBack
																					onClick={() =>
																						setTogglePrepareLetter(
																							false,
																						)
																					}
																					icon={
																						<CloseOutlined />
																					}
																					size="large"
																				/>
																				<label
																					className="headerTagStyle"
																					style={{
																						fontWeight: 600,
																					}}
																				>
																					Prepare
																					Letter
																				</label>
																			</Space>
																		}
																		placement="right"
																		width={
																			550
																		}
																		zIndex={
																			9999
																		}
																		open={
																			togglePrepareLetter
																		}
																		onClose={() =>
																			setTogglePrepareLetter(
																				false,
																			)
																		}
																		closable={
																			false
																		}
																		bodyStyle={{
																			padding:
																				'24px',
																		}}
																		maskClosable={
																			false
																		}
																	>
																		{/* <XThemeAffixCard>
																					<Row className="align-items-center">
																						<Col
																							xs={
																								24
																							}
																						>
																							<Space align="center">
																								<XButtonBack
																									onClick={() =>
																										setTogglePrepareLetter(
																											false,
																										)
																									}
																									icon={
																										<ArrowLeftOutlined />
																									}
																									size="large"
																								/>
																								<label
																									class="headerTagStyle"
																									style={{
																										fontWeight: 600,
																									}}
																								>
																									Prepare
																									Letter
																								</label>
																							</Space>
																						</Col>
																					</Row>
																					<XDivider
																						dashed="true"
																						className="mt-3 mb-1"
																					/> */}
																		<PrepareLetter
																			denialLetterActionPerform={
																				denialLetterActionPerform
																			}
																			setDenialLetterActionPerform={
																				setDenialLetterActionPerform
																			}
																			setSupportingDocActionPerform={
																				setSupportingDocActionPerform
																			}
																			setParentDocumentsToDisplay={
																				setDocumentsToDisplay
																			}
																			setParentPatientData={
																				setPatientData
																			}
																			approveModalOpen={
																				approveModalOpen
																			}
																			revenueCycle={
																				patientData.revenue_cycle
																			}
																			setTogglePrepareLetter={
																				setTogglePrepareLetter
																			}
																			setLoading={
																				setAppealLetterLoading
																			}
																			setDownloadLoading={
																				setDownloadLoading
																			}
																			setApproveModalOpen={
																				setApproveModalOpen
																			}
																			setTypeAppeal={
																				setTypeAppeal
																			}
																		/>
																		{/* </XThemeAffixCard> */}
																	</Drawer>
																</>
																{/* )} */}
																{/* </div>
																	<div className="back">
																		{!togglePrepareLetter && ( */}
																<>
																	{mainDataLoading ? (
																		<>
																			<Skeleton
																				active
																				paragraph={{
																					rows: 6,
																				}}
																			/>
																		</>
																	) : (
																		<>
																			{timelineData &&
																			timelineData.length >
																				0 ? (
																				<NewTimeline
																					setCurrentActiveCollapse={
																						setCurrentActiveCollapse
																					}
																					setPrevActiveCollapse={
																						setPrevActiveCollapse
																					}
																					prevActiveCollapse={
																						prevActiveCollapse
																					}
																					currentActiveCollapse={
																						currentActiveCollapse
																					}
																					handlePreviewBeforUploa
																					d={
																						handlePreviewBeforUpload
																					}
																					handleChange={
																						handleChange
																					}
																					handleDownload={
																						handleDownload
																					}
																					selectedOption={
																						selectedOption
																					}
																					filterByLabel={
																						filterByLabel
																					}
																					denialReasonData={
																						denialReasonData
																					}
																					handleSelect={
																						handleSelect
																					}
																					handleDateChange={
																						handleDateChange
																					}
																					disableFutureDates={
																						disableFutureDates
																					}
																					updateModalOpen={
																						updateModalOpen
																					}
																					updateForm={
																						updateForm
																					}
																					handleSubmit={
																						handleSubmit
																					}
																					patientData={
																						patientData
																					}
																					handleInputChange={
																						handleInputChange
																					}
																					setApproveModalOpen={
																						setApproveModalOpen
																					}
																					revenueCycleStatus={
																						revenueCycleStatus
																					}
																					setRevenueCycleStage={
																						setRevenueCycleStage
																					}
																					revenueCycleStage={
																						revenueCycleStage
																					}
																					status={
																						formData?.status
																					}
																					setUpdateModalOpen={
																						setUpdateModalOpen
																					}
																					setRevenueCycleStatus={
																						setRevenueCycleStatus
																					}
																					revenueCycleFormData={
																						revenueCycleFormData
																					}
																					setRevenueCycleFormData={
																						setRevenueCycleFormData
																					}
																					timelineData={
																						timelineData
																					}
																					togglePrepareLetter={
																						togglePrepareLetter
																					}
																					setTogglePrepareLetter={
																						setTogglePrepareLetter
																					}
																					fileList={
																						fileList
																					}
																					setFileList={
																						setFileList
																					}
																					setUpdatedFileList={
																						setUpdatedFileList
																					}
																					updatedFileList={
																						updatedFileList
																					}
																					id={
																						id
																					}
																					setSelectedOption={
																						setSelectedOption
																					}
																					medicareCoverage={
																						pageContent
																							.medicalCoverage[0]
																					}
																					case_status={
																						patientData.status
																					}
																					setFlag={
																						setFlag
																					}
																					setDownloadLoading={
																						setDownloadLoading
																					}
																					updateModalButtonText={
																						updateModalButtonText
																					}
																					updateCaseLoading={
																						updateCaseLoading
																					}
																					viewAppealLetter={
																						viewAppealLetter
																					}
																				/>
																			) : (
																				<>

																				</>
																			)}
																		</>
																	)}
																</>
																{/* )}
																	</div>
																</div> */}
															</>
														</>
													</Col>
												</Row>
											</Col>

											{/* called common component start */}
											<CaseOperations
												currentRevision={
													currentRevision
												}
												aipa={false}
												previewMode={caseClosed}
												matchGender={matchGender}
												dateOfBirth={dateOfBirth}
												loading={loading}
												patientData={patientData}
												mainDataLoading={
													mainDataLoading
												}
												handleClinicalDocsChange={
													handleClinicalDocsChange
												}
												clinicalDocumentFileList={
													clinicalDocumentFileList
												}
												clinicalDocsForm={
													clinicalDocsForm
												}
												handleUploadCancel={
													handleUploadCancel
												}
												clinicalDocsLoading={
													clinicalDocsLoading
												}
												setIsClinicalUploadModalOpen={
													setIsClinicalUploadModalOpen
												}
												isClinicalUploadModalOpen={
													isClinicalUploadModalOpen
												}
												setPreviewImage={
													setPreviewImage
												}
												previewImage={previewImage}
												setPreviewTitle={
													setPreviewTitle
												}
												previewTitle={previewTitle}
												setPdfPreviewOpen={
													setPdfPreviewOpen
												}
												pdfPreviewOpen={pdfPreviewOpen}
												documentsToDisplay={
													documentsToDisplay
												}
												clinicalSummaryTextLoading={
													clinicalSummaryTextLoading
												}
												setClinicalSummaryTextLoading={
													setClinicalSummaryTextLoading
												}
												setShowClinicalTextArea={
													setShowClinicalTextArea
												}
												showClinicalTextArea={
													showClinicalTextArea
												}
												setFormData={setFormData}
												formData={formData}
												id={id}
												editCase={editCase}
												setPageContent={setPageContent}
												pageContent={pageContent}
												clinicalDocumentsToDisplay={
													clinicalDocumentsToDisplay
												}
												feedbackId={feedbackId}
												reviseCoverage={reviseCoverage}
												lastAnalysisData={
													lastAnalysisData
												}
												setLoading={setLoading}
												getBase64={getBase64}
												setClinicalDocsLoading={
													setClinicalDocsLoading
												}
												setSubmitClinicalDocs={
													setSubmitClinicalDocs
												}
												setUpdatedClinicalDocumentFileList={
													setUpdatedClinicalDocumentFileList
												}
												form={form}
												setModalTextArea={
													setModalTextArea
												}
												setModalOpen={setModalOpen}
												handleCodeClick={
													handleCodeClick
												}
												modalOpen={modalOpen}
												sendFeedback={sendFeedback}
												sendFeedbackState={
													sendFeedbackState
												}
												modalTextArea={modalTextArea}
												updatePageContent={
													updatePageContent
												}
												missingFieldsForm={
													missingFieldsForm
												}
												missingFieldsCardRef={
													missingFieldsCardRef
												}
												handleAddOption={
													handleAddOption
												}
												missingFields={missingFields}
												missingFieldInstructions={
													missingFieldInstructions
												}
												setMissingFieldsModal={
													setMissingFieldsModal
												}
												setMissingFieldInstructions={
													setMissingFieldInstructions
												}
												setMissingFields={
													setMissingFields
												}
												missingFieldTitle={
													missingFieldTitle
												}
												missingFieldsModal={
													missingFieldsModal
												}
												selectedProvider={''}
												selectedModel={''}
												revenueCycle={''}
												collapsed={collapsed}
											/>
											{/* called common component end */}

											{checkModulePermissions(
												'ma-plan-appeals-processing',
											).sub_modules.includes(
												'update-coverage',
											) ||
											checkModulePermissions(
												'case-filing',
											).sub_modules.includes(
												'update-coverage',
											) ? (
												!caseClosed &&
												!missingFieldsModal && (
													<Col
														xs={{
															span: 24,
															order: 2,
														}}
														sm={{
															span: 24,
															order: 2,
														}}
														md={{
															span: 24,
															order: 1,
														}}
														lg={14}
														xl={24}
													>
														<>
															{/* AIPA buttons */}
															<div className="showMobile">
																<Row
																	gutter={
																		(15, 15)
																	}
																	className="mt-4"
																>
																	<Col
																		xs={12}
																	>
																		<XButtonConfirm
																			className="w-100"
																			type="primary"
																			size="large"
																			shape="round"
																			style={{
																				background:
																					'#fff',
																			}}
																			icon={
																				<img
																					className="rotateButton"
																					src="/images/like-icon.svg"
																					alt=""
																				/>
																			}
																			onClick={() => {
																				form.setFieldsValue(
																					{
																						modal_text_area:
																							pageContent.medicalCoverage
																								? pageContent
																										.medicalCoverage[1]
																								: '',
																						medicare_flag:
																							pageContent.medicalCoverage
																								? pageContent
																										.medicalCoverage[0]
																								: '',
																					},
																				);
																				setModalTextArea(
																					pageContent
																						.medicalCoverage[1],
																				);
																				setModalOpen(
																					[
																						true,
																						`Edit Medicare Coverage`,
																						pageContent
																							.medicalCoverage[1],
																						1,
																						'feedbackSummary',
																					],
																				);
																			}}
																		>
																			Refine
																		</XButtonConfirm>
																	</Col>
																	<Col
																		xs={12}
																	>
																		<XButtonConfirm
																			className="w-100"
																			type="primary"
																			size="large"
																			shape="round"
																			style={{
																				background:
																					'#fff',
																			}}
																			icon={
																				<img
																					src="/images/like-icon.svg"
																					alt=""
																				/>
																			}
																			loading={
																				LooksGoodLoading
																			}
																			onClick={() => {
																				setLooksGoodLoading(
																					true,
																				);
																				sendFeedback(
																					{
																						feedback_id:
																							feedbackId,
																						feedback:
																							'positive',
																						status: 'approved',
																						response:
																							pageContent.medicalCoverage,
																					},
																				);
																			}}
																		>
																			Looks
																			Good
																		</XButtonConfirm>
																	</Col>
																	<Col
																		xs={24}
																		className="mt-4"
																	>
																		<XButtonConfirm
																			className="btnActive w-100"
																			loading={
																				coverageloading
																			}
																			onClick={() => {
																				setCoverageLoading(
																					true,
																				);
																				sendFeedback(
																					{
																						feedback_id:
																							feedbackId,
																						status: 'approved',
																						response:
																							pageContent.medicalCoverage,
																					},
																				);
																			}}
																			disabled={
																				pageContent.status ===
																				'approved'
																					? true
																					: false
																			}
																			type="primary"
																			shape="round"
																			size="large"
																		>
																			Confirm
																			Coverage
																		</XButtonConfirm>
																	</Col>
																</Row>
															</div>
															<div className="showDesktop">
																<Row className="text-end">
																	<Col
																		xs={24}
																		lg={12}
																		className="mt-4"
																	>
																		<Space
																			style={{
																				width: '100%',
																			}}
																		>
																			<XButtonConfirm
																				className="mb-2 mb-md-0 mb-sm-0"
																				type="primary"
																				size="large"
																				shape="round"
																				style={{
																					background:
																						'#fff',
																				}}
																				icon={
																					<img
																						className="rotateButton"
																						src="/images/like-icon.svg"
																						alt=""
																					/>
																				}
																				onClick={() => {
																					form.setFieldsValue(
																						{
																							modal_text_area:
																								pageContent.medicalCoverage
																									? pageContent
																											.medicalCoverage[1]
																									: '',
																							medicare_flag:
																								pageContent.medicalCoverage
																									? pageContent
																											.medicalCoverage[0]
																									: '',
																						},
																					);
																					setModalTextArea(
																						pageContent
																							.medicalCoverage[1],
																					);
																					setModalOpen(
																						[
																							true,
																							`Edit Medicare Coverage`,
																							pageContent
																								.medicalCoverage[1],
																							1,
																							'feedbackSummary',
																						],
																					);
																				}}
																			/>
																			<XButtonConfirm
																				className="mb-2 mb-md-0 mb-sm-0"
																				type="primary"
																				size="large"
																				shape="round"
																				style={{
																					background:
																						'#fff',
																				}}
																				icon={
																					<img
																						src="/images/like-icon.svg"
																						alt=""
																					/>
																				}
																				loading={
																					LooksGoodLoading
																				}
																				onClick={() => {
																					setLooksGoodLoading(
																						true,
																					);
																					sendFeedback(
																						{
																							feedback_id:
																								feedbackId,
																							feedback:
																								'positive',
																							status: 'approved',
																							response:
																								pageContent.medicalCoverage,
																						},
																					);
																				}}
																			/>
																		</Space>
																	</Col>
																	<Col
																		xs={24}
																		lg={12}
																		className="mt-4 text-md-end"
																	>
																		<XButtonConfirm
																			loading={
																				coverageloading
																			}
																			onClick={() => {
																				setCoverageLoading(
																					true,
																				);
																				sendFeedback(
																					{
																						feedback_id:
																							feedbackId,
																						status: 'approved',
																						response:
																							pageContent.medicalCoverage,
																					},
																				);
																			}}
																			disabled={
																				pageContent.status ===
																				'approved'
																					? true
																					: false
																			}
																			type="primary"
																			shape="round"
																			size="large"
																			className="btnActive"
																		>
																			Confirm
																			Coverage
																		</XButtonConfirm>
																	</Col>
																</Row>
															</div>
														</>
													</Col>
												)
											) : (
												<></>
											)}
										</>
									)}
								</Row>

								{/* //Todo Commented the Chatbox in the Demo Branch */}
								<ChatBoxWrap>
									{chatOpen && <ChatBox case_id={id} />}
									{patientData.status == 'allocated' ? (
										<></>
									) : pageContent.medicalCoverage[0] ==
									  'Yes' ? (
										<ChatButton
											type="text"
											onClick={() => {
												setChatOpen(!chatOpen);
											}}
											className={
												chatOpen ? 'open' : 'close'
											}
										>
											{chatOpen ? (
												<>
													<img
														src="/images/chat-cross-icon.svg"
														alt="Close chat Icon"
														width="60px"
														height="60px"
													/>
												</>
											) : (
												<img
													src="/images/chat-icon.svg"
													alt="Open chat Icon"
													width="60px"
													height="60px"
												/>
											)}
										</ChatButton>
									) : (
										<></>
									)}
								</ChatBoxWrap>
							</>
						) : (
							<Result
								status="403"
								title="403"
								subTitle="Sorry, you are not authorized to access this page."
								extra={
									<Button
										type="primary"
										onClick={() => navigate('/')}
									>
										Back Home
									</Button>
								}
							/>
						)}
					</XThemeContainer>

					<XVerHistorySticky type="primary" onClick={showVersionLog}>
						Version Log
					</XVerHistorySticky>

					<DrawerVersionLog
						title="Version Log"
						closable={{ 'aria-label': 'Close Button' }}
						open={openVersionLog}
						onClose={() => setOpenVersionLog(false)}
						zIndex={9999}
					>
						<div className="contentPadding">
							<div className="scrollAfix p-2">
								{revisionList?.length > 0 ? (
									revisionList.flatMap((revision, i) =>
										revision.changes.map(
											(change, index) => {
												// Render each change here
												return (
													<XThemeCardBackBgVersion
														className={`mb-3 ${
															currentRevision?._id ===
															change._id
																? 'activeBg'
																: ''
														}`}
													>
														<Row
															gutter={(15, 15)}
															className="align-items-center"
														>
															<Col xl={3} xs={3}>
																<RevisionHistoryNum
																	style={{
																		backgroundColor:
																			currentRevision?._id &&
																			currentRevision?._id.toString() ===
																				change._id.toString()
																				? ''
																				: '',
																	}}
																>
																	<span
																		style={{
																			color:
																				currentRevision?._id &&
																				currentRevision?._id.toString() ===
																					change._id.toString()
																					? ''
																					: '#f9f9f9',
																		}}
																		class="RevisionNum"
																	>
																		v
																		{
																			revision.revisionNumber
																		}
																		.
																		{revision
																			.changes
																			.length -
																			index}
																	</span>
																</RevisionHistoryNum>
															</Col>
															<Col xs={16}>
																<>
																	<RevisionHisTitle>
																		Edited{' '}
																		{
																			change.name
																		}
																		<div className="revisionHisIcons">
																			{getTimeAgoOrDate(
																				revision.updatedAt,
																			)}
																		</div>
																	</RevisionHisTitle>
																</>
															</Col>
															{currentRevision?._id &&
															currentRevision?._id.toString() ===
																change._id.toString() ? null : i ===
																	0 &&
															  index === 0 ? (
																<Col
																	xs={5}
																	className="text-center"
																>
																	<CurrentRevision
																		role="button"
																		onClick={() => {
																			setVersionNumber(
																				`v${
																					revision.revisionNumber
																				}.${
																					revision
																						.changes
																						.length -
																					index
																				}`,
																			);
																			setCurrentRevision(
																				change,
																			);
																		}}
																	>
																		Current
																	</CurrentRevision>
																</Col>
															) : (
																<Col
																	xs={5}
																	className="text-end"
																>
																	<EyeIcon
																		size="middle"
																		shape="circle"
																		onClick={() => {
																			setVersionNumber(
																				`v${
																					revision.revisionNumber
																				}.${
																					revision
																						.changes
																						.length -
																					index
																				}`,
																			);
																			setCurrentRevision(
																				change,
																			);
																		}}
																	>
																		<EyeOutlined />
																	</EyeIcon>
																</Col>
															)}
														</Row>
													</XThemeCardBackBgVersion>
												);
											},
										),
									)
								) : (
									<div
										style={{
											textAlign: 'center',
											padding: '20px',
											color: '#555',
										}}
									>
										No revision history available
									</div>
								)}
							</div>
						</div>
					</DrawerVersionLog>

					{/* //todo Drawer of the Coding Tools Start */}
					<XAddCodeSticky type="primary" onClick={showIcdCptDrawer}>
						Coding Tools
					</XAddCodeSticky>

					<DrawerCodingTools
						// previewMode={false}
						activeTab={activeTab}
						setActiveTab={setActiveTab}
						openIcdDrawer={openIcdDrawer}
						setOpenIcdDrawer={setOpenIcdDrawer}
						openCptDrawer={openCptDrawer}
						setOpenCptDrawer={setOpenCptDrawer}
						previewMode={caseClosed}
						fixed={false}
						icdform={icdform}
						cptform={cptform}
						activeCode={activeCode}
						setActiveCode={setActiveCode}
						closeIcdCptDrawer={closeIcdCptDrawer}
						openIcdCptDrawer={openIcdCptDrawer}
						handleCodeClick={handleCodeClick}
						setModalOpen={setModalOpen}
						setModalTextArea={setModalTextArea}
						closeIcdCptDrawer2={closeIcdCptDrawer2}
						openIcdCptDrawer2={openIcdCptDrawer2}
						modalOpen={modalOpen}
						updatePageContent={updatePageContent}
						modalTextArea={modalTextArea}
						setIcdCodes={setIcdCodes}
						icdCodes={icdCodes}
						searchResults={searchResults}
						setSearchResults={setSearchResults}
						icdLoading={icdLoading}
						setIcdLoading={setIcdLoading}
						triggeredBySearch={triggeredBySearch}
						setTriggeredBySearch={setTriggeredBySearch}
						triggeredByEnter={triggeredByEnter}
						setTriggeredByEnter={setTriggeredByEnter}
						loadMore={loadMore}
						setLoadMore={setLoadMore}
						icdSearchLoading={icdSearchLoading}
						setIcdSearchLoading={setIcdSearchLoading}
						cptCodes={cptCodes}
						setCptCodes={setCptCodes}
						cptLoading={cptLoading}
						setCptLoading={setCptLoading}
						cptSearchResults={cptSearchResults}
						setCptSearchResults={setCptSearchResults}
						cptTriggeredBySearch={cptTriggeredBySearch}
						setCptTriggeredBySearch={setCptTriggeredBySearch}
						cptTriggeredByEnter={cptTriggeredByEnter}
						setCptTriggeredByEnter={setCptTriggeredByEnter}
						cptLoadMore={cptLoadMore}
						setCptLoadMore={setCptLoadMore}
						cptSearchLoading={cptSearchLoading}
						setCptSearchLoading={setCptSearchLoading}
						icdFilters={icdFilters}
						setIcdFilters={setIcdFilters}
						cptFilters={cptFilters}
						setCptFilters={setCptFilters}
					/>

					<XModal
						centered
						open={''}
						onOk={() => setThanksModal([false, ''])}
						className="modalButton"
						okText="Submit"
						footer={null}
					>
						<Row gutter={(15, 0)} className="mt-4">
							<Col xs={24} lg={{ span: 12, offset: 6 }}>
								<XLottieMargin>
									<XLottie
										animationData={Thanks}
										loop={true}
									/>
								</XLottieMargin>

								<XPara1 className="mt-5 mb-4">
									{thanksModal[1]}
								</XPara1>
							</Col>
						</Row>
					</XModal>

					{/* Modal for adding new option */}
					<XThemeModal
						title={
							<>
								<span class="modalTitleIcon">
									<img
										className="img-fluid"
										src="/images/add-modal-icon.svg"
										alt="Add New Option"
									/>
								</span>
								Add New Option
							</>
						}
						open={newCheckBoxModal[0]}
						onOk={handleNewCheckBoxModal}
						okText="Submit"
						onCancel={() => {
							setNewCheckBoxModal([false, null]);
							setNewOptionText('');
							newOptionForm.setFieldsValue({});
							newOptionForm.resetFields();
						}}
						okButtonProps={{
							className: 'xThemeButtonSubmit',
						}}
						cancelButtonProps={{
							className: 'xThemeCancelSubmit',
						}}
					>
						<Row gutter={(15, 15)} className="mt-4">
							<Col xs={24}>
								<XThemeForm
									form={newOptionForm}
									name="groupForm"
									layout="vertical"
									autoComplete="off"
								>
									<XThemeForm.Item
										name={'new-option'}
										rules={[
											{
												required: true,
												message: 'Please input option',
											},
										]}
									>
										<XThemeInputText
											size="large"
											className="largeInputForms"
											value={newOptionText}
											onChange={(e) =>
												setNewOptionText(e.target.value)
											}
											placeholder="Enter new option text"
										/>
									</XThemeForm.Item>
								</XThemeForm>
							</Col>
						</Row>
					</XThemeModal>

					<XModal
						centered
						open={thanksModal[0]}
						closable={false} // Hide the close icon
						className="modalButton"
						okText="Submit"
						footer={null}
					>
						<Row
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
							gutter={(15, 0)}
							className="mt-2"
						>
							<Col xs={24} lg={18}>
								<XLottieMargin>
									<XLottie
										animationData={Thanks}
										loop={true}
									/>
								</XLottieMargin>

								<XPara1
									style={{ textAlign: 'center' }}
									className="mt-0"
								>
									{thanksModal[1]}
								</XPara1>
							</Col>
						</Row>
					</XModal>
				</>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	editCaseState: state.editCase,
	addCaseState: state.addCase,
	analyseCoverageState: state.analyseCoverage,
	reviseCoverageState: state.reviseCoverage,
	sendFeedbackState: state.sendFeedback,
	getAnalysisState: state.getAnalysis,
	getAppealLetterState: state.getAppealLetter,
	saveAppealLetterState: state.saveAppealLetter,
	generateAppealLetterState: state.generateAppealLetter,
	getConfigurationsState: state.getConfigurations,
	getRevisionState: state.getRevision,
});

const mapDispatchToProps = (dispatch) => ({
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	addCase: (data) => dispatch(addCaseApi(data)),
	addCaseReset: () => dispatch(addCaseReset()),
	sendFeedback: (params) => dispatch(sendFeedbackApi(params)),
	sendFeedbackReset: () => dispatch(sendFeedbackReset()),
	analyseCoverage: (params) => dispatch(analyseCoverageApi(params)),
	analyseCoverageReset: () => dispatch(analyseCoverageReset()),
	reviseCoverage: (params) => dispatch(reviseCoverageApi(params)),
	reviseCoverageReset: () => dispatch(reviseCoverageReset()),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: (params) => dispatch(getAnalysisReset(params)),
	getAppealLetter: (params) => dispatch(getAppealLetterApi(params)),
	getAppealLetterReset: () => dispatch(getAppealLetterReset()),
	saveAppealLetter: (params) => dispatch(saveAppealLetterApi(params)),
	generateAppealLetter: (params) => dispatch(generateAppealLetterApi(params)),
	getConfigurations: (params) => dispatch(getConfigurationsApi(params)),
	getRevision: (params) => dispatch(getRevisionApi(params)),
	getRevisionReset: (params) => dispatch(getRevisionReset(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseForm);
